import React, { useEffect, useState, useRef, createElement } from 'react';
import { Link } from 'react-router-dom';
import { Users, UsersRound, TrendingUp, Target, Award, Download, ChevronDown, ChevronUp, ChevronsUpDown, Filter, Calendar, ArrowUpRight, ArrowDownRight, Minus, Zap, MessageCircle, Send, ThumbsUp, AlertTriangle, TrendingDown, Clock, CheckCircle, Star, Mail, Video, Sparkles, BarChart3, Home, UserCog, FileText, Bell, X, RefreshCw, Search } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line, AreaChart, Area, PieChart, Pie, Cell, Legend, ComposedChart } from 'recharts';
import { motion, AnimatePresence } from 'framer-motion';
import { AIInsightPopover } from './AIInsightPopover';
// Mock data for demonstration
const mockLearners = [{
  id: 1,
  name: 'Linda Taylor',
  email: 'linda.taylor@example.com',
  assessments: 3,
  avgScore: 85,
  lastAttempt: '2024-01-15'
}, {
  id: 2,
  name: 'John Smith',
  email: 'john.smith@example.com',
  assessments: 2,
  avgScore: 72,
  lastAttempt: '2024-01-14'
}, {
  id: 3,
  name: 'Sarah Johnson',
  email: 'sarah.j@example.com',
  assessments: 4,
  avgScore: 91,
  lastAttempt: '2024-01-16'
}, {
  id: 4,
  name: 'Michael Chen',
  email: 'mchen@example.com',
  assessments: 3,
  avgScore: 78,
  lastAttempt: '2024-01-13'
}, {
  id: 5,
  name: 'Emily Davis',
  email: 'emily.d@example.com',
  assessments: 2,
  avgScore: 88,
  lastAttempt: '2024-01-15'
}];
const moduleData = [{
  module: 'HTML Basics',
  mastery: 85,
  misinformation: 15,
  avgScore: 82,
  attempts: 45,
  confidentCorrect: 80,
  uncertainCorrect: 8,
  confidentIncorrect: 5,
  uncertainIncorrect: 7
}, {
  module: 'CSS Fundamentals',
  mastery: 78,
  misinformation: 22,
  avgScore: 76,
  attempts: 42,
  confidentCorrect: 75,
  uncertainCorrect: 10,
  confidentIncorrect: 8,
  uncertainIncorrect: 7
}, {
  module: 'JavaScript Basics',
  mastery: 72,
  misinformation: 28,
  avgScore: 71,
  attempts: 38,
  confidentCorrect: 65,
  uncertainCorrect: 10,
  confidentIncorrect: 15,
  uncertainIncorrect: 10
}, {
  module: 'Responsive Design',
  mastery: 80,
  misinformation: 20,
  avgScore: 79,
  attempts: 35,
  confidentCorrect: 78,
  uncertainCorrect: 10,
  confidentIncorrect: 6,
  uncertainIncorrect: 6
}];
const scoreDistribution = [{
  range: '0-20%',
  count: 2
}, {
  range: '21-40%',
  count: 5
}, {
  range: '41-60%',
  count: 8
}, {
  range: '61-80%',
  count: 15
}, {
  range: '81-100%',
  count: 12
}];
const attemptTrends = [{
  attempt: '1st',
  avgScore: 68
}, {
  attempt: '2nd',
  avgScore: 75
}, {
  attempt: '3rd',
  avgScore: 82
}, {
  attempt: '4th',
  avgScore: 86
}];
const individualModulePerformance = [{
  module: 'HTML Basics',
  score: 92,
  mastery: 95,
  misinformation: 5,
  attempts: 2,
  // Confidence breakdown data
  confidentCorrect: 80,
  uncertainCorrect: 8,
  confidentIncorrect: 5,
  uncertainIncorrect: 7
}, {
  module: 'CSS Fundamentals',
  score: 85,
  mastery: 88,
  misinformation: 12,
  attempts: 1,
  confidentCorrect: 75,
  uncertainCorrect: 10,
  confidentIncorrect: 8,
  uncertainIncorrect: 7
}, {
  module: 'JavaScript Basics',
  score: 78,
  mastery: 75,
  misinformation: 25,
  attempts: 3,
  confidentCorrect: 65,
  uncertainCorrect: 10,
  confidentIncorrect: 15,
  uncertainIncorrect: 10
}, {
  module: 'Responsive Design',
  score: 88,
  mastery: 90,
  misinformation: 10,
  attempts: 1,
  confidentCorrect: 78,
  uncertainCorrect: 10,
  confidentIncorrect: 6,
  uncertainIncorrect: 6
}];
const performanceTableData = [{
  name: 'David Hansen',
  finalScore: '100%',
  improvement: '+0%',
  attempts: 1,
  confidentCorrect: '100%',
  confidentIncorrect: '0%'
}, {
  name: 'Chad Mundt',
  finalScore: '100%',
  improvement: '+0%',
  attempts: 1,
  confidentCorrect: '100%',
  confidentIncorrect: '0%'
}, {
  name: 'Claudiu Budurlean',
  finalScore: '100%',
  improvement: '+0%',
  attempts: 1,
  confidentCorrect: '100%',
  confidentIncorrect: '0%'
}, {
  name: 'Tiffany La Mertha',
  finalScore: '100%',
  improvement: '+0%',
  attempts: 1,
  confidentCorrect: '91.67%',
  confidentIncorrect: '0%'
}, {
  name: 'Uttam Parmar',
  finalScore: '100%',
  improvement: '+0%',
  attempts: 1,
  confidentCorrect: '100%',
  confidentIncorrect: '0%'
}, {
  name: 'Jacob Zanders',
  finalScore: '100%',
  improvement: '+0%',
  attempts: 1,
  confidentCorrect: '100%',
  confidentIncorrect: '0%'
}, {
  name: 'Jeevan Kandimalla',
  finalScore: '100%',
  improvement: '+0%',
  attempts: 1,
  confidentCorrect: '100%',
  confidentIncorrect: '0%'
}, {
  name: 'Shannon Catt',
  finalScore: '100%',
  improvement: '+0%',
  attempts: 1,
  confidentCorrect: '100%',
  confidentIncorrect: '0%'
}, {
  name: 'Guna Bellampalli',
  finalScore: '100%',
  improvement: '+0%',
  attempts: 1,
  confidentCorrect: '83.33%',
  confidentIncorrect: '0%'
}, {
  name: 'Alexis Bensky',
  finalScore: '100%',
  improvement: '+0%',
  attempts: 1,
  confidentCorrect: '0%',
  confidentIncorrect: '0%'
}];
type PerformanceTableSortKey = 'name' | 'finalScore' | 'improvement' | 'attempts' | 'confidentCorrect' | 'confidentIncorrect';
// Action items mock data
const actionItems = [{
  id: 1,
  type: 'urgent',
  category: 'struggling',
  learner: {
    name: 'John Smith',
    email: 'john.smith@example.com',
    avatar: 'JS'
  },
  insight: 'Failed JavaScript Basics 3 times with declining scores',
  details: 'Score dropped from 68% → 65% → 58% over 3 attempts. High misinformation rate (45%) on core concepts.',
  module: 'JavaScript Basics',
  lastActivity: '2 days ago',
  priority: 'high',
  suggestedActions: ['Schedule 1-on-1 check-in', 'Recommend prerequisite review', 'Assign peer mentor']
}, {
  id: 2,
  type: 'macro',
  category: 'skill-issue',
  scope: 'system',
  insight: 'CSS Fundamentals has 68% failure rate across all learners',
  details: '42 of 62 learners (68%) are failing CSS Fundamentals on first attempt. Average score is 54%, well below the 70% passing threshold. Common struggle areas: Flexbox (82% error rate), Grid Layout (76% error rate), and Positioning (71% error rate).',
  module: 'CSS Fundamentals',
  affectedLearners: 42,
  lastActivity: 'Ongoing',
  priority: 'high',
  suggestedActions: ['Review skill content difficulty', 'Add supplemental Flexbox tutorials', 'Create interactive Grid exercises', 'Schedule instructor review session']
}, {
  id: 3,
  type: 'celebrate',
  category: 'high-performer',
  learner: {
    name: 'Sarah Johnson',
    email: 'sarah.j@example.com',
    avatar: 'SJ'
  },
  insight: 'Achieved 95%+ on all 4 assessments on first attempt',
  details: 'Consistent high performance with strong mastery across all modules. Completed skill 2 weeks ahead of schedule.',
  module: 'All Modules',
  lastActivity: '1 day ago',
  priority: 'positive',
  suggestedActions: ['Send congratulations', 'Invite to mentor program', 'Recommend advanced track']
}, {
  id: 4,
  type: 'macro',
  category: 'low-engagement',
  scope: 'system',
  insight: 'Responsive Design skill has only 12% enrollment rate',
  details: 'Only 30 of 248 active learners (12%) have started Responsive Design, despite it being a core requirement. Skill has been available for 45 days. Learners cite "intimidating title" and "unclear prerequisites" as barriers in feedback surveys.',
  module: 'Responsive Design',
  affectedLearners: 218,
  lastActivity: 'Last 45 days',
  priority: 'medium',
  suggestedActions: ['Rename skill to be more approachable', 'Create promotional campaign', 'Add clear prerequisite guidance', 'Send targeted enrollment emails']
}, {
  id: 5,
  type: 'attention',
  category: 'at-risk',
  learner: {
    name: 'Michael Chen',
    email: 'mchen@example.com',
    avatar: 'MC'
  },
  insight: 'No activity for 7 days, last score was 62%',
  details: 'Was on track but has been inactive. Last assessment showed struggle with CSS layouts.',
  module: 'CSS Fundamentals',
  lastActivity: '7 days ago',
  priority: 'medium',
  suggestedActions: ['Send check-in message', 'Share additional resources', 'Extend deadline']
}, {
  id: 6,
  type: 'macro',
  category: 'content-gap',
  scope: 'system',
  insight: 'High misinformation rate (34%) on JavaScript async concepts',
  details: 'Across 156 attempts on JavaScript Basics, async/await and Promises questions show 34% misinformation rate (learners confidently selecting wrong answers). This is 2.8x higher than the skill average of 12%. Suggests content may be introducing misconceptions rather than clarifying concepts.',
  module: 'JavaScript Basics',
  affectedLearners: 89,
  lastActivity: 'Last 30 days',
  priority: 'high',
  suggestedActions: ['Audit async/await lesson content', 'Add visual diagrams for event loop', 'Create hands-on async exercises', 'Review question phrasing for clarity']
}, {
  id: 7,
  type: 'celebrate',
  category: 'improvement',
  learner: {
    name: 'Emily Davis',
    email: 'emily.d@example.com',
    avatar: 'ED'
  },
  insight: 'Improved from 65% to 88% after focused practice',
  details: 'Showed significant improvement on HTML Basics retake. Mastery increased from 60% to 92%.',
  module: 'HTML Basics',
  lastActivity: '1 day ago',
  priority: 'positive',
  suggestedActions: ['Send encouragement', 'Highlight progress', 'Share success story']
}, {
  id: 8,
  type: 'macro',
  category: 'success-pattern',
  scope: 'system',
  insight: 'HTML Basics completion rate increased 23% after video additions',
  details: 'After adding supplemental video tutorials 3 weeks ago, HTML Basics first-attempt pass rate jumped from 64% to 87%. Average completion time decreased from 4.2 to 3.1 attempts. Learner feedback mentions "videos made concepts click" (mentioned in 78% of positive reviews).',
  module: 'HTML Basics',
  affectedLearners: 124,
  lastActivity: 'Last 3 weeks',
  priority: 'positive',
  suggestedActions: ['Apply video strategy to other skills', 'Document what made videos effective', 'Share success with content team', 'Create video templates for consistency']
}, {
  id: 9,
  type: 'urgent',
  category: 'struggling',
  learner: {
    name: 'Alex Rivera',
    email: 'alex.r@example.com',
    avatar: 'AR'
  },
  insight: 'Consistently scoring below 50% across all modules',
  details: 'Attempted 5 assessments with average score of 45%. High misinformation rate suggests fundamental gaps.',
  module: 'Multiple Modules',
  lastActivity: '3 days ago',
  priority: 'high',
  suggestedActions: ['Schedule urgent meeting', 'Assess learning needs', 'Create custom plan']
}, {
  id: 10,
  type: 'macro',
  category: 'time-pattern',
  scope: 'system',
  insight: 'Weekend attempts have 41% higher failure rate than weekday',
  details: 'Analysis of 892 assessment attempts shows weekend attempts (Sat-Sun) have 41% higher failure rate (58% vs 41%). Possible causes: less instructor support available, learners rushing through content, or fatigue from weekday work. Pattern consistent across all skills.',
  module: 'All Skills',
  affectedLearners: 187,
  lastActivity: 'Last 60 days',
  priority: 'medium',
  suggestedActions: ['Add weekend office hours', 'Send "take your time" reminders on Fridays', 'Analyze if weekend learners need different support', 'Consider weekend-specific resources']
}, {
  id: 11,
  type: 'attention',
  category: 'engagement',
  learner: {
    name: 'Lisa Wong',
    email: 'lisa.w@example.com',
    avatar: 'LW'
  },
  insight: 'Taking unusually long between attempts (10+ days)',
  details: 'Scores are adequate (75% avg) but engagement pattern suggests time management issues.',
  module: 'Responsive Design',
  lastActivity: '5 days ago',
  priority: 'medium',
  suggestedActions: ['Check on progress', 'Offer time management tips', 'Discuss barriers']
}];
export function AnalyticsDashboard() {
  const [selectedLearner, setSelectedLearner] = useState<number | null>(null);
  const [isLearnerDropdownOpen, setIsLearnerDropdownOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [selectedSkill, setSelectedSkill] = useState<string>('All Skills Combined');
  const [isSkillDropdownOpen, setIsSkillDropdownOpen] = useState(false);
  const [selectedChartType, setSelectedChartType] = useState<string>('Score Distribution');
  const [isChartTypeDropdownOpen, setIsChartTypeDropdownOpen] = useState(false);
  const [activeTab, setActiveTab] = useState<'assessment' | 'progress'>('assessment');
  const userMenuRef = useRef<HTMLDivElement>(null);
  const skillDropdownRef = useRef<HTMLDivElement>(null);
  const learnerDropdownRef = useRef<HTMLDivElement>(null);
  const chartTypeDropdownRef = useRef<HTMLDivElement>(null);
  const skillOptions = ['All Skills Combined', 'HTML Basics', 'CSS Fundamentals', 'JavaScript Basics', 'Responsive Design'];
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
        setIsUserMenuOpen(false);
      }
      if (skillDropdownRef.current && !skillDropdownRef.current.contains(event.target as Node)) {
        setIsSkillDropdownOpen(false);
      }
      if (learnerDropdownRef.current && !learnerDropdownRef.current.contains(event.target as Node)) {
        setIsLearnerDropdownOpen(false);
      }
      if (chartTypeDropdownRef.current && !chartTypeDropdownRef.current.contains(event.target as Node)) {
        setIsChartTypeDropdownOpen(false);
      }
    };
    if (isUserMenuOpen || isSkillDropdownOpen || isLearnerDropdownOpen || isChartTypeDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isUserMenuOpen, isSkillDropdownOpen, isLearnerDropdownOpen, isChartTypeDropdownOpen]);
  const totalLearners = mockLearners.length;
  const totalAssessments = mockLearners.reduce((sum, l) => sum + l.assessments, 0);
  const overallAvgScore = Math.round(mockLearners.reduce((sum, l) => sum + l.avgScore, 0) / totalLearners);
  const overallMastery = Math.round(moduleData.reduce((sum, m) => sum + m.mastery, 0) / moduleData.length);
  // Derive viewMode from state
  const viewMode = selectedLearner ? 'individual' : 'aggregate';
  const selectedLearnerData = selectedLearner ? mockLearners.find(l => l.id === selectedLearner) : null;
  const COLORS = ['#30718D', '#007558', '#FBBC04', '#DB3725'];
  return <div className="flex-1 bg-gray-50 min-h-screen" data-id="element-245" data-mp="p9p4wipaedhw">
      {/* Top Navigation */}
      <div className="bg-white border-b border-gray-200" data-id="element-246" data-mp="u78jjjpwcsad">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-247" data-mp="u9uqbh4yr3rj">
          <div className="flex items-center h-16" data-id="element-248" data-mp="y8kdg1fszzod">
            {/* Logo */}
            <div className="text-[#DB3725] font-bold text-xl" data-id="element-249" data-mp="138orzlx5ikby">LOGO</div>

            {/* Navigation Links */}
            <nav className="flex items-center gap-4 sm:gap-8 ml-6 sm:ml-12" data-id="element-250" data-mp="186gm8ml9qijb">
              <Link to="/admin" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-251" data-mp="1d62vym1w1gnd">
                <Home size={18} data-id="element-252" data-mp="1lyocrwlyld9k" />
                <span className="hidden sm:inline" data-id="element-253" data-mp="1lxv6ewqwwpry">Admin Hub</span>
              </Link>
              <Link to="/analytics" className="flex items-center gap-2 text-[#30718D] border-b-2 border-[#30718D] pb-[22px] pt-[22px] transition-colors text-sm font-medium" data-id="element-254" data-mp="1qysm92og97qa">
                <BarChart3 size={18} data-id="element-255" data-mp="262lx542yf27r" />
                <span className="hidden sm:inline" data-id="element-256" data-mp="211xvloh3n2za">Analytics</span>
              </Link>
              <Link to="/feedback" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-257" data-mp="2140smsgo5wdi">
                <FileText size={18} data-id="element-258" data-mp="1s3chc5inua4b" />
                <span className="hidden sm:inline" data-id="element-259" data-mp="2os1ytuqdl0pr">Reports</span>
              </Link>
              <Link to="/assessment" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-260" data-mp="2jsfj9en2r8ds">
                <UserCog size={18} data-id="element-261" data-mp="2b03wq3v30533" />
                <span className="hidden sm:inline" data-id="element-262" data-mp="2b0x3h4u1iul8">Users</span>
              </Link>
            </nav>

            {/* Right Side - User Info */}
            <div className="flex items-center gap-2 sm:gap-4 ml-auto" data-id="element-263" data-mp="37k4lbmpp7b7x">
              <Link to="/alerts" className="relative p-2 text-gray-600 hover:text-gray-900 transition-colors" data-id="element-264" data-mp="32qi6bnw2av8y">
                <Bell size={20} data-id="element-265" data-mp="3r5sfpjvyajnp" />
                <span className="absolute top-1 right-1 w-2 h-2 bg-[#DB3725] rounded-full" data-id="element-266" data-mp="3r6u22kif2skq"></span>
              </Link>
              <div className="relative" ref={userMenuRef} data-id="element-267" data-mp="3ciz7eykume50">
                <button onClick={() => setIsUserMenuOpen(!isUserMenuOpen)} className="flex items-center gap-3 hover:bg-gray-50 rounded-lg px-2 py-1 transition-colors" data-id="element-268" data-mp="3hffvxtvymuim">
                  <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 text-sm font-medium" data-id="element-269" data-mp="dy7hlk0fycsn">
                    LT
                  </div>
                  <span className="hidden sm:inline text-sm font-medium text-gray-900" data-id="element-270" data-mp="40jheek2gd33">
                    Linda Taylor
                  </span>
                  <ChevronDown size={16} className="text-gray-600" data-id="element-271" data-mp="2jul9eitrfhtg" />
                </button>

                {/* User Dropdown Menu */}
                {isUserMenuOpen && <div className="absolute top-full right-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-lg z-50" data-id="element-272" data-mp="16sdmejv05lgg">
                    <div className="py-2" data-id="element-273" data-mp="11x81nodc6cty">
                      <Link to="/profile" className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-274" data-mp="1ftllh45ceqbl">
                        <Users size={18} className="text-gray-600" data-id="element-275" data-mp="o3yw5ysiebgp" />
                        <span className="font-medium text-gray-900" data-id="element-276" data-mp="j55k8asvesin">
                          Profile
                        </span>
                      </Link>
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-277" data-mp="wxlt3s8gdkrh">
                        <Home size={18} className="text-gray-600" data-id="element-278" data-mp="4eoliz7megpg" />
                        <span className="font-medium text-gray-900" data-id="element-279" data-mp="duu3vuyyjrt">
                          Learner Hub
                        </span>
                      </button>
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-280" data-mp="2qlcnad038hue">
                        <UserCog size={18} className="text-gray-600" data-id="element-281" data-mp="30amiw2u54in9" />
                        <span className="font-medium text-gray-900" data-id="element-282" data-mp="30cz4cpz3xb52">
                          Admin Hub
                        </span>
                      </button>
                      <Link to="/settings" className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-283" data-mp="3a7r2pw0ik20w">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-600" data-id="element-284" data-mp="3j7nz6jt5a56i">
                          <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" data-id="element-285" data-mp="4dyeld5a0r98"></path>
                          <circle cx="12" cy="12" r="3" data-id="element-286" data-mp="37vgk3dxktm6h"></circle>
                        </svg>
                        <span className="font-medium text-gray-900" data-id="element-287" data-mp="122i9polem2a9">
                          Settings
                        </span>
                      </Link>
                      <div className="border-t border-gray-200 my-2" data-id="element-288" data-mp="2ezzaqc1qx1qi"></div>
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-289" data-mp="2exw90ur8dk5y">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-600" data-id="element-290" data-mp="25ysorngbuypv">
                          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" data-id="element-291" data-mp="2owc4f9xajfl9"></path>
                          <polyline points="16 17 21 12 16 7" data-id="element-292" data-mp="2jykbcckwtnfh"></polyline>
                          <line x1="21" y1="12" x2="9" y2="12" data-id="element-293" data-mp="3heppe8xj372x"></line>
                        </svg>
                        <span className="font-medium text-gray-900" data-id="element-294" data-mp="3cnhet9kgpfo6">
                          Logout
                        </span>
                      </button>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Header */}
      <div data-phoebe-tour="analytics" className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 pt-6 sm:pt-8 pb-4" data-id="element-295" data-mp="3tvidt4ak3mkz">
        <div data-id="element-296" data-mp="1uls9p3r2wxi">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900" data-id="element-297" data-mp="1qy1uytlqqn0">
            Analytics Dashboard
          </h1>
          <p className="text-gray-600 mt-1 text-sm sm:text-base" data-id="element-298" data-mp="br72qpyjh08q">
            Track learner progress and assessment performance
          </p>
        </div>
      </div>

      {/* Tabs */}
      <div data-phoebe-tour="analytics-tabs" className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-299" data-mp="lha3jcbwjihm">
        <div className="border-b border-gray-200 flex items-center" data-id="element-300" data-mp="pive2r0yrkon">
          <button onClick={() => setActiveTab('assessment')} className={`relative px-4 sm:px-6 py-3 text-sm sm:text-base font-bold transition-colors ${activeTab === 'assessment' ? 'text-gray-900' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-301" data-mp="pkojy43r60vl">
            Assessment Analytics
            {activeTab === 'assessment' && <span className="absolute left-0 right-0 -bottom-px h-1 bg-[#DB3725]" data-id="element-302" data-mp="qlalgjh1pd55"></span>}
          </button>
          <button onClick={() => setActiveTab('progress')} className={`relative px-4 sm:px-6 py-3 text-sm sm:text-base font-bold transition-colors ${activeTab === 'progress' ? 'text-gray-900' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-303" data-mp="ln917v7vv7s3">
            Learner Progress
            {activeTab === 'progress' && <span className="absolute left-0 right-0 -bottom-px h-1 bg-[#DB3725]" data-id="element-304" data-mp="7s6rsy3tv0aj"></span>}
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 pt-6 pb-6" data-id="element-305" data-mp="1j7vd7l1fnr98">
        {activeTab === 'progress' ? <LearnerProgressTable data-id="element-306" data-mp="1eczhoawzmlrd" /> : viewMode === 'aggregate' ? <AggregateView totalLearners={totalLearners} totalAssessments={totalAssessments} overallAvgScore={overallAvgScore} overallMastery={overallMastery} moduleData={moduleData} scoreDistribution={scoreDistribution} attemptTrends={attemptTrends} COLORS={COLORS} selectedSkill={selectedSkill} setSelectedSkill={setSelectedSkill} isSkillDropdownOpen={isSkillDropdownOpen} setIsSkillDropdownOpen={setIsSkillDropdownOpen} skillDropdownRef={skillDropdownRef} skillOptions={skillOptions} selectedLearner={selectedLearner} setSelectedLearner={setSelectedLearner} selectedLearnerData={selectedLearnerData} isLearnerDropdownOpen={isLearnerDropdownOpen} setIsLearnerDropdownOpen={setIsLearnerDropdownOpen} learnerDropdownRef={learnerDropdownRef} data-id="element-307" data-mp="2w6x6tskj3zkp" /> : selectedLearnerData ? <IndividualView learner={selectedLearnerData} modulePerformance={individualModulePerformance} actionItems={actionItems} COLORS={COLORS} selectedSkill={selectedSkill} setSelectedSkill={setSelectedSkill} isSkillDropdownOpen={isSkillDropdownOpen} setIsSkillDropdownOpen={setIsSkillDropdownOpen} skillDropdownRef={skillDropdownRef} skillOptions={skillOptions} selectedLearner={selectedLearner} setSelectedLearner={setSelectedLearner} selectedLearnerData={selectedLearnerData} isLearnerDropdownOpen={isLearnerDropdownOpen} setIsLearnerDropdownOpen={setIsLearnerDropdownOpen} learnerDropdownRef={learnerDropdownRef} data-id="element-308" data-mp="ha1tqufac2ss" /> : <div className="bg-white rounded-xl p-12 text-center shadow-sm border border-gray-100" data-id="element-309" data-mp="36t3mamj4qazg">
            <Users size={48} className="mx-auto text-gray-400 mb-4" data-id="element-310" data-mp="1mc2rusilkgrq" />
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-311" data-mp="1qcwk1y32ohqf">
              Select a Learner
            </h3>
            <p className="text-gray-600" data-id="element-312" data-mp="1vbhl1zq5f5fx">
              Choose a learner from the dropdown above to view their individual
              performance
            </p>
          </div>}
      </div>
    </div>;
}
const learnerProgressData = [{
  name: 'Alexis Bensky',
  module: 'Empathetic Communication and Emotional Management',
  attempts: 1,
  firstScore: '91.67%',
  finalScore: '91.67%',
  improvement: '+0%',
  ccFirst: '0%',
  ccFinal: '0%'
}, {
  name: 'Alexis Bensky',
  module: 'Giving and Receiving Feedback',
  attempts: 1,
  firstScore: '100%',
  finalScore: '100%',
  improvement: '+0%',
  ccFirst: '0%',
  ccFinal: '0%'
}, {
  name: 'Alexis Bensky',
  module: 'Leading with Effective Communication',
  attempts: 3,
  firstScore: '75%',
  finalScore: '100%',
  improvement: '+25%',
  ccFirst: '0%',
  ccFinal: '0%'
}, {
  name: 'Chad Mundt',
  module: 'Giving and Receiving Feedback',
  attempts: 1,
  firstScore: '100%',
  finalScore: '100%',
  improvement: '+0%',
  ccFirst: '100%',
  ccFinal: '100%'
}, {
  name: 'Claudiu Budurlean',
  module: 'Giving and Receiving Feedback',
  attempts: 1,
  firstScore: '100%',
  finalScore: '100%',
  improvement: '+0%',
  ccFirst: '100%',
  ccFinal: '100%'
}, {
  name: 'Cora Asher',
  module: 'Empathetic Communication and Emotional Management',
  attempts: 1,
  firstScore: '75%',
  finalScore: '75%',
  improvement: '+0%',
  ccFirst: '75%',
  ccFinal: '75%'
}, {
  name: 'David Hansen',
  module: 'Giving and Receiving Feedback',
  attempts: 1,
  firstScore: '100%',
  finalScore: '100%',
  improvement: '+0%',
  ccFirst: '100%',
  ccFinal: '100%'
}, {
  name: 'Guna Bellampalli',
  module: 'Giving and Receiving Feedback',
  attempts: 1,
  firstScore: '100%',
  finalScore: '100%',
  improvement: '+0%',
  ccFirst: '83.33%',
  ccFinal: '83.33%'
}, {
  name: 'Jacob Zanders',
  module: 'Empathetic Communication and Emotional Management',
  attempts: 2,
  firstScore: '83.33%',
  finalScore: '100%',
  improvement: '+16.67%',
  ccFirst: '83.33%',
  ccFinal: '100%'
}, {
  name: 'Jacob Zanders',
  module: 'Giving and Receiving Feedback',
  attempts: 1,
  firstScore: '100%',
  finalScore: '100%',
  improvement: '+0%',
  ccFirst: '100%',
  ccFinal: '100%'
}, {
  name: 'Jacob Zanders',
  module: 'Leading with Effective Communication',
  attempts: 3,
  firstScore: '83.33%',
  finalScore: '100%',
  improvement: '+16.67%',
  ccFirst: '83.33%',
  ccFinal: '100%'
}, {
  name: 'Maya Patel',
  module: 'Empathetic Communication and Emotional Management',
  attempts: 2,
  firstScore: '66.67%',
  finalScore: '91.67%',
  improvement: '+25%',
  ccFirst: '50%',
  ccFinal: '83.33%'
}, {
  name: 'Maya Patel',
  module: 'Giving and Receiving Feedback',
  attempts: 1,
  firstScore: '100%',
  finalScore: '100%',
  improvement: '+0%',
  ccFirst: '100%',
  ccFinal: '100%'
}, {
  name: 'Noah Williams',
  module: 'Leading with Effective Communication',
  attempts: 2,
  firstScore: '75%',
  finalScore: '91.67%',
  improvement: '+16.67%',
  ccFirst: '66.67%',
  ccFinal: '83.33%'
}, {
  name: 'Olivia Brown',
  module: 'Empathetic Communication and Emotional Management',
  attempts: 1,
  firstScore: '83.33%',
  finalScore: '83.33%',
  improvement: '+0%',
  ccFirst: '83.33%',
  ccFinal: '83.33%'
}, {
  name: 'Olivia Brown',
  module: 'Giving and Receiving Feedback',
  attempts: 3,
  firstScore: '58.33%',
  finalScore: '91.67%',
  improvement: '+33.34%',
  ccFirst: '41.67%',
  ccFinal: '75%'
}, {
  name: 'Priya Shah',
  module: 'Leading with Effective Communication',
  attempts: 1,
  firstScore: '100%',
  finalScore: '100%',
  improvement: '+0%',
  ccFirst: '91.67%',
  ccFinal: '91.67%'
}, {
  name: 'Quinn Rivera',
  module: 'Empathetic Communication and Emotional Management',
  attempts: 2,
  firstScore: '75%',
  finalScore: '100%',
  improvement: '+25%',
  ccFirst: '66.67%',
  ccFinal: '100%'
}, {
  name: 'Rachel Kim',
  module: 'Giving and Receiving Feedback',
  attempts: 1,
  firstScore: '91.67%',
  finalScore: '91.67%',
  improvement: '+0%',
  ccFirst: '83.33%',
  ccFinal: '83.33%'
}, {
  name: 'Samuel Okafor',
  module: 'Leading with Effective Communication',
  attempts: 3,
  firstScore: '50%',
  finalScore: '83.33%',
  improvement: '+33.33%',
  ccFirst: '33.33%',
  ccFinal: '66.67%'
}];
type LearnerProgressSortKey = 'name' | 'module' | 'attempts' | 'firstScore' | 'finalScore' | 'improvement' | 'ccFirst' | 'ccFinal';
function parsePercent(value: string | number) {
  if (typeof value === 'number') return value;
  const cleaned = value.replace('%', '').replace('+', '').trim();
  const n = parseFloat(cleaned);
  return isNaN(n) ? 0 : n;
}
function LearnerProgressTable() {
  const [showDetails, setShowDetails] = useState(true);
  const [sortKey, setSortKey] = useState<LearnerProgressSortKey>('name');
  const [sortDir, setSortDir] = useState<'asc' | 'desc'>('asc');
  const [currentPage, setCurrentPage] = useState(1);
  const [moduleFilter, setModuleFilter] = useState<string>('All Modules');
  const [moduleSearch, setModuleSearch] = useState<string>('');
  const [isModuleDropdownOpen, setIsModuleDropdownOpen] = useState(false);
  const [isPaginationDropdownOpen, setIsPaginationDropdownOpen] = useState(false);
  const moduleDropdownRef = useRef<HTMLDivElement>(null);
  const paginationDropdownRef = useRef<HTMLDivElement>(null);
  const itemsPerPage = 10;
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (moduleDropdownRef.current && !moduleDropdownRef.current.contains(event.target as Node)) {
        setIsModuleDropdownOpen(false);
      }
      if (paginationDropdownRef.current && !paginationDropdownRef.current.contains(event.target as Node)) {
        setIsPaginationDropdownOpen(false);
      }
    };
    if (isModuleDropdownOpen || isPaginationDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isModuleDropdownOpen, isPaginationDropdownOpen]);
  const handleSort = (key: LearnerProgressSortKey) => {
    if (sortKey === key) {
      setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortDir('asc');
    }
    setCurrentPage(1);
  };
  const moduleFilteredData = moduleFilter === 'All Modules' ? learnerProgressData : learnerProgressData.filter(r => r.module === moduleFilter);
  const sortedData = [...moduleFilteredData].sort((a, b) => {
    let valA: string | number = a[sortKey];
    let valB: string | number = b[sortKey];
    if (sortKey === 'attempts' || sortKey === 'firstScore' || sortKey === 'finalScore' || sortKey === 'improvement' || sortKey === 'ccFirst' || sortKey === 'ccFinal') {
      const numA = parsePercent(valA as any);
      const numB = parsePercent(valB as any);
      return sortDir === 'asc' ? numA - numB : numB - numA;
    }
    const strA = String(valA).toLowerCase();
    const strB = String(valB).toLowerCase();
    return sortDir === 'asc' ? strA.localeCompare(strB) : strB.localeCompare(strA);
  });
  const totalPages = Math.max(1, Math.ceil(sortedData.length / itemsPerPage));
  const safeCurrentPage = Math.min(currentPage, totalPages);
  const paginatedData = sortedData.slice((safeCurrentPage - 1) * itemsPerPage, safeCurrentPage * itemsPerPage);
  const isActive = (key: LearnerProgressSortKey) => sortKey === key;
  const SortArrow = ({
    columnKey
  }: {
    columnKey: LearnerProgressSortKey;
  }) => {
    if (!isActive(columnKey)) {
      return <ChevronsUpDown size={14} className="text-gray-400" data-id="element-313" data-mp="33jnne5fw9ofk" />;
    }
    return sortDir === 'asc' ? <ChevronUp size={14} className="text-[#30718D]" data-id="element-314" data-mp="2ziloxqtsxgen" /> : <ChevronDown size={14} className="text-[#30718D]" data-id="element-315" data-mp="2uksjx148isfy" />;
  };
  const headerBtnClass = (columnKey: LearnerProgressSortKey) => `flex items-center gap-1 text-left text-sm font-medium transition-colors ${isActive(columnKey) ? 'text-[#30718D]' : 'text-gray-700 hover:text-gray-900'}`;
  const cellActiveClass = (columnKey: LearnerProgressSortKey) => isActive(columnKey) ? 'bg-[#30718D]/5' : '';
  const headerActiveClass = (columnKey: LearnerProgressSortKey) => isActive(columnKey) ? 'bg-[#30718D]/10' : '';
  return <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-316" data-mp="26w0ycsl5h8c5">
      {/* Header */}
      <div className="px-4 sm:px-6 py-5 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3" data-id="element-317" data-mp="1x5iy60osh8eq">
        <div data-id="element-318" data-mp="1n8wcxasjwfc6">
          <h4 className="text-base font-bold text-gray-900 mb-0.5 flex items-center gap-2" data-id="element-319" data-mp="1n966t9gpv6n5">
            <UsersRound size={22} className="text-[#30718D]" data-id="element-320" data-mp="1s7r4b14l3c7w" />
            Detailed Summary Table by Learner
          </h4>
          <p className="text-sm text-gray-500 ml-[26px]" data-id="element-321" data-mp="2fxbpzrs4gnkv">
            Individual learner performance metrics by skill module
          </p>
        </div>
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3" data-id="element-322" data-mp="2kyrdrrlop86y">
          {/* Skill module search dropdown */}
          <div className="relative" ref={moduleDropdownRef} data-id="element-323" data-mp="2b63e8p3bkq4j">
            <button type="button" onClick={() => {
            setIsModuleDropdownOpen(!isModuleDropdownOpen);
            setModuleSearch('');
          }} className="flex items-center gap-2 px-3 sm:px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white text-sm font-bold text-gray-900 w-full sm:min-w-[240px]" data-id="element-324" data-mp="2b4inlak4lrby">
              <Target size={16} className="text-[#30718D]" data-id="element-325" data-mp="11094p3e3hhlz" />
              <span className="flex-1 text-left truncate" data-id="element-326" data-mp="10zpkth4vwj5b">{moduleFilter}</span>
              <ChevronDown size={16} className={`transition-transform text-gray-500 ${isModuleDropdownOpen ? 'rotate-180' : ''}`} data-id="element-327" data-mp="x0712oosue42" />
            </button>

            {isModuleDropdownOpen && <div className="absolute top-full mt-2 right-0 w-full sm:w-[320px] bg-white border border-gray-200 rounded-lg shadow-lg z-20" data-id="element-328" data-mp="4ckztn31nlkd">
                <div className="p-2 border-b border-gray-100" data-id="element-329" data-mp="dan3kae5wsbc">
                  <div className="relative" data-id="element-330" data-mp="1tp6aw8517nyd">
                    <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-331" data-mp="1to4urp95sb9s" />
                    <input type="text" autoFocus value={moduleSearch} onChange={e => setModuleSearch(e.target.value)} placeholder="Search skill modules..." className="w-full pl-8 pr-3 py-2 border border-gray-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#30718D]/40 focus:border-[#30718D]" data-id="element-332" data-mp="28t92f6ioyd8v" />
                  </div>
                </div>
                <div className="max-h-64 overflow-y-auto py-1" data-id="element-333" data-mp="2wgh6jl4dvg9b">
                  {(() => {
                const uniqueModules = Array.from(new Set(learnerProgressData.map(r => r.module))).sort((a, b) => a.localeCompare(b));
                const options = ['All Modules', ...uniqueModules];
                const q = moduleSearch.trim().toLowerCase();
                const filtered = q ? options.filter(n => n.toLowerCase().includes(q)) : options;
                if (filtered.length === 0) {
                  return <div className="px-4 py-3 text-sm text-gray-500" data-id="element-334" data-mp="ysdbrerm0wcm">
                          No skill modules found
                        </div>;
                }
                return filtered.map(name => <button key={name} onClick={() => {
                  setModuleFilter(name);
                  setIsModuleDropdownOpen(false);
                  setModuleSearch('');
                  setCurrentPage(1);
                }} className={`w-full px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm ${moduleFilter === name ? 'bg-[#30718D]/5 text-[#30718D] font-semibold' : 'text-gray-700'}`} data-id="element-335" data-mp="1mipu7jkhebhg">
                        {name}
                      </button>);
              })()}
                </div>
              </div>}
          </div>

          <button type="button" className="self-start sm:self-auto flex items-center gap-2 px-4 py-2 bg-[#DB3725] text-white text-sm font-medium rounded-lg hover:bg-[#c02f1f] transition-colors" data-id="element-336" data-mp="3hpxana19ahg6">
            <Download size={16} data-id="element-337" data-mp="32rv7h0y4zxzg" />
            Download
          </button>
        </div>
      </div>

      {/* Table */}
      {showDetails && <div className="overflow-x-auto" data-id="element-338" data-mp="2y0d6icw45xeh">
          <table className="w-full text-sm" data-id="element-339" data-mp="2xzbt41rmkytl">
            <thead data-id="element-340" data-mp="2u0mkemhj85ga">
              <tr className="border-b border-gray-200 bg-gray-50" data-id="element-341" data-mp="2u02yyvsoayxi">
                <th className={`text-left px-4 sm:px-6 py-3 whitespace-nowrap transition-colors ${headerActiveClass('name')}`} data-id="element-342" data-mp="2p19nf8wy5hzz">
                  <button onClick={() => handleSort('name')} className={headerBtnClass('name')} data-id="element-343" data-mp="2k3872vqwnws7">
                    Learner Name
                    <SortArrow columnKey="name" data-id="element-344" data-mp="250q6ld0cq8at" />
                  </button>
                </th>
                <th className={`text-left px-4 sm:px-6 py-3 whitespace-nowrap transition-colors ${headerActiveClass('module')}`} data-id="element-345" data-mp="29zjkh6jjw1bi">
                  <button onClick={() => handleSort('module')} className={headerBtnClass('module')} data-id="element-346" data-mp="2jubkeh0lv09g">
                    Skill Module
                    <SortArrow columnKey="module" data-id="element-347" data-mp="1r80gawdsih7w" />
                  </button>
                </th>
                <th className={`text-left px-4 sm:px-6 py-3 whitespace-nowrap transition-colors ${headerActiveClass('attempts')}`} data-id="element-348" data-mp="1w50n59igro02">
                  <button onClick={() => handleSort('attempts')} className={headerBtnClass('attempts')} data-id="element-349" data-mp="13hmmb0bna8ao">
                    Attempts
                    <SortArrow columnKey="attempts" data-id="element-350" data-mp="10fi713hiwo9k" />
                  </button>
                </th>
                <th className={`text-left px-4 sm:px-6 py-3 whitespace-nowrap transition-colors ${headerActiveClass('firstScore')}`} data-id="element-351" data-mp="vgyj4xjdd2ek">
                  <button onClick={() => handleSort('firstScore')} className={headerBtnClass('firstScore')} data-id="element-352" data-mp="1a7nwo6kaytll">
                    First Score
                    <SortArrow columnKey="firstScore" data-id="element-353" data-mp="hj09u6jwnw5x" />
                  </button>
                </th>
                <th className={`text-left px-4 sm:px-6 py-3 whitespace-nowrap transition-colors ${headerActiveClass('finalScore')}`} data-id="element-354" data-mp="cjxan2qlwk5v">
                  <button onClick={() => handleSort('finalScore')} className={headerBtnClass('finalScore')} data-id="element-355" data-mp="mefj0l6yx3w0">
                    Final Score
                    <SortArrow columnKey="finalScore" data-id="element-356" data-mp="1xunoovhp4vbw" />
                  </button>
                </th>
                <th className={`text-left px-4 sm:px-6 py-3 whitespace-nowrap transition-colors ${headerActiveClass('improvement')}`} data-id="element-357" data-mp="25d3qjljf60hr">
                  <button onClick={() => handleSort('improvement')} className={headerBtnClass('improvement')} data-id="element-358" data-mp="1wes3fthrhku2">
                    Improvement
                    <SortArrow columnKey="improvement" data-id="element-359" data-mp="2o67lrbcacleh" />
                  </button>
                </th>
                <th className={`text-left px-4 sm:px-6 py-3 max-w-[160px] transition-colors ${headerActiveClass('ccFirst')}`} data-id="element-360" data-mp="2t37szpkvfu76">
                  <button onClick={() => handleSort('ccFirst')} className={`${headerBtnClass('ccFirst')} items-start text-left`} data-id="element-361" data-mp="2jeg1fijq3bws">
                    <span className="leading-snug" data-id="element-362" data-mp="3buqtnprfaw61">
                      Confident & Correct Rate First Attempt
                    </span>
                    <SortArrow columnKey="ccFirst" data-id="element-363" data-mp="1o7gubtqynq9e" />
                  </button>
                </th>
                <th className={`text-left px-4 sm:px-6 py-3 max-w-[160px] transition-colors ${headerActiveClass('ccFinal')}`} data-id="element-364" data-mp="1j6b0ttph7yyt">
                  <button onClick={() => handleSort('ccFinal')} className={`${headerBtnClass('ccFinal')} items-start text-left`} data-id="element-365" data-mp="1a6nzf7wqyt5r">
                    <span className="leading-snug" data-id="element-366" data-mp="26yri421e3mx2">
                      Confident & Correct Rate Final Attempt
                    </span>
                    <SortArrow columnKey="ccFinal" data-id="element-367" data-mp="1x6c0j5u090cp" />
                  </button>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-368" data-mp="1t5a0wnw6ema7">
              {paginatedData.map((row, idx) => <tr key={idx} className="border-b border-gray-100 last:border-b-0 hover:bg-gray-50 transition-colors" data-id="element-369" data-mp="2pog7zgqdwd5k" data-mpi={idx}>
                  <td className={`px-4 sm:px-6 py-4 font-medium text-gray-900 align-middle whitespace-nowrap transition-colors ${cellActiveClass('name')}`} data-id="element-370" data-mp="7elgr8hv6bg5">
                    {row.name}
                  </td>
                  <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle transition-colors ${cellActiveClass('module')}`} data-id="element-371" data-mp="gdf7wjcfe9mb">
                    {row.module}
                  </td>
                  <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle tabular-nums transition-colors ${cellActiveClass('attempts')}`} data-id="element-372" data-mp="qb3dy5fhf3js">
                    {row.attempts}
                  </td>
                  <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle tabular-nums whitespace-nowrap transition-colors ${cellActiveClass('firstScore')}`} data-id="element-373" data-mp="144kr98hkrk1d">
                    {row.firstScore}
                  </td>
                  <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle tabular-nums whitespace-nowrap transition-colors ${cellActiveClass('finalScore')}`} data-id="element-374" data-mp="3a5n1gw3rz4wm">
                    {row.finalScore}
                  </td>
                  <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle tabular-nums whitespace-nowrap transition-colors ${cellActiveClass('improvement')}`} data-id="element-375" data-mp="3jx161ial2uwm">
                    {row.improvement}
                  </td>
                  <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle tabular-nums max-w-[160px] transition-colors ${cellActiveClass('ccFirst')}`} data-id="element-376" data-mp="3ovb3jzjs67le">
                    {row.ccFirst}
                  </td>
                  <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle tabular-nums max-w-[160px] transition-colors ${cellActiveClass('ccFinal')}`} data-id="element-377" data-mp="1nqujw4dpyab">
                    {row.ccFinal}
                  </td>
                </tr>)}
            </tbody>
          </table>

          {/* Pagination */}
          {sortedData.length > 0 && <div className="flex items-center justify-between px-4 sm:px-6 py-3 border-t border-gray-200" data-id="element-378" data-mp="o0bpt08ja7po">
              <p className="text-sm text-gray-600" data-id="element-379" data-mp="97iapfx6btlj">
                Showing {(safeCurrentPage - 1) * itemsPerPage + 1}–
                {Math.min(safeCurrentPage * itemsPerPage, sortedData.length)} of{' '}
                {sortedData.length}
              </p>
              <div className="flex items-center gap-2" data-id="element-380" data-mp="58iyrbd0ywkl">
                <span className="text-sm text-gray-600" data-id="element-381" data-mp="3mg4k9ldm2oyu">Page</span>
                <div className="relative" ref={paginationDropdownRef} data-id="element-382" data-mp="3mhpibkz4wq1g">
                  <button type="button" onClick={() => setIsPaginationDropdownOpen(open => !open)} aria-haspopup="listbox" aria-expanded={isPaginationDropdownOpen} aria-label="Select page" className={`flex min-w-14 items-center justify-between rounded-md border bg-white py-1 pl-2 pr-2 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-[#30718D]/20 ${isPaginationDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]/20 text-[#30718D]' : 'border-gray-300 text-gray-700'}`} data-id="element-383" data-mp="3rfqx3tpj2374">
                    <span data-id="element-384" data-mp="3pvo0xx4zenke">{safeCurrentPage}</span>
                    <ChevronDown size={14} aria-hidden="true" className={`ml-2 text-gray-400 transition-transform ${isPaginationDropdownOpen ? 'rotate-180' : ''}`} data-id="element-385" data-mp="3pwfmef4v74wy" />
                  </button>
                  {isPaginationDropdownOpen && <div role="listbox" aria-label="Select page" className="absolute bottom-full z-30 mb-1 max-h-60 min-w-full overflow-y-auto overflow-x-hidden rounded-lg border border-gray-200 bg-white shadow-lg" data-id="element-386" data-mp="3bxzguriqnkge">
                      {Array.from({
                length: totalPages
              }, (_, i) => i + 1).map(page => <button key={page} type="button" role="option" aria-selected={safeCurrentPage === page} onClick={() => {
                setCurrentPage(page);
                setIsPaginationDropdownOpen(false);
              }} className={`flex w-full items-center border-b border-gray-100 px-3 py-2 text-left text-sm transition-colors last:border-b-0 ${safeCurrentPage === page ? 'bg-[#30718D]/10 font-medium text-[#30718D]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-387" data-mp="1wcxg90mb00gh">
                          {page}
                        </button>)}
                    </div>}
                </div>
                <span className="text-sm text-gray-600" data-id="element-388" data-mp="3infv8y2nlyw1">of {totalPages}</span>
              </div>
            </div>}
        </div>}
    </div>;
}
function ActionItemsView({
  actionItems,
  selectedSkill
}) {
  const [activeFilter, setActiveFilter] = useState<'all' | 'urgent' | 'attention' | 'celebrate'>('all');
  const [selectedAction, setSelectedAction] = useState<number | null>(null);
  const [viewType, setViewType] = useState<'all' | 'individual' | 'macro'>('all');
  // Modal states
  const [messageModal, setMessageModal] = useState<{
    isOpen: boolean;
    item: any | null;
  }>({
    isOpen: false,
    item: null
  });
  const [meetingModal, setMeetingModal] = useState<{
    isOpen: boolean;
    item: any | null;
  }>({
    isOpen: false,
    item: null
  });
  const [kudosModal, setKudosModal] = useState<{
    isOpen: boolean;
    item: any | null;
  }>({
    isOpen: false,
    item: null
  });
  // Filter action items by selected skill
  const skillFilteredItems = selectedSkill === 'All Skills Combined' ? actionItems : actionItems.filter(item => item.module === selectedSkill || item.module === 'All Modules' || item.module === 'All Skills' || item.module === 'Multiple Modules');
  const filteredItems = skillFilteredItems.filter(item => {
    // Filter by view type
    if (viewType === 'individual' && item.type === 'macro') return false;
    if (viewType === 'macro' && item.type !== 'macro') return false;
    // Filter by priority
    if (activeFilter === 'all') return true;
    if (activeFilter === 'urgent') return item.priority === 'high';
    if (activeFilter === 'attention') return item.priority === 'medium';
    if (activeFilter === 'celebrate') return item.priority === 'positive';
    return true;
  });
  const urgentCount = skillFilteredItems.filter(a => a.priority === 'high').length;
  const attentionCount = skillFilteredItems.filter(a => a.priority === 'medium').length;
  const celebrateCount = skillFilteredItems.filter(a => a.priority === 'positive').length;
  const macroCount = skillFilteredItems.filter(a => a.type === 'macro').length;
  const individualCount = skillFilteredItems.filter(a => a.type !== 'macro').length;
  // Get recipient name for modals
  const getRecipientName = (item: any) => {
    if (item.learner) return item.learner.name;
    return 'Team';
  };
  const getRecipientFirstName = (item: any) => {
    if (item.learner) return item.learner.name.split(' ')[0];
    return 'Team';
  };
  return <div data-id="element-389" data-mp="3ld6ovlymgv3">
      {/* Message Modal */}
      <AnimatePresence data-id="element-390" data-mp="3ohfk6ade0s3">
        {messageModal.isOpen && messageModal.item && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={() => setMessageModal({
        isOpen: false,
        item: null
      })} data-id="element-391" data-mp="7q2ya89l59a7">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-white rounded-xl shadow-2xl max-w-lg w-full" onClick={e => e.stopPropagation()} data-id="element-392" data-mp="1j6nrkzguk8g8">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-393" data-mp="2zlp4ikg9qunu">
                <div className="flex items-center gap-3" data-id="element-394" data-mp="2urb2w0b0jraq">
                  <div className="w-12 h-12 rounded-lg bg-[#30718D] flex items-center justify-center" data-id="element-395" data-mp="2ecv6zoj4ugim">
                    <Mail size={24} className="text-white" data-id="element-396" data-mp="2jdiyscf6r1dw" />
                  </div>
                  <h2 className="text-xl font-bold text-gray-900" data-id="element-397" data-mp="25e01kenwxagd">
                    Send Message
                  </h2>
                </div>
                <button onClick={() => setMessageModal({
              isOpen: false,
              item: null
            })} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-398" data-mp="2ae5nde7i42qj">
                  <X size={20} className="text-gray-500" data-id="element-399" data-mp="2o9zsdm55m7yd" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6" data-id="element-400" data-mp="3h083wv56pu3z">
                <p className="text-gray-600 mb-1" data-id="element-401" data-mp="3gz6suqo657m9">
                  Your message has been successfully sent to
                </p>
                <p className="text-lg font-bold text-gray-900 mb-6" data-id="element-402" data-mp="3v60cw40qyekq">
                  {getRecipientName(messageModal.item)}
                </p>

                <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-403" data-mp="3r3n7jgpwwioh">
                  <p className="text-sm text-gray-500 mb-2" data-id="element-404" data-mp="8qp3oyq015p1">Message Preview:</p>
                  <p className="text-gray-700 leading-relaxed" data-id="element-405" data-mp="3rm9yafgylwd">
                    "Hi {getRecipientFirstName(messageModal.item)}, I noticed
                    your recent assessment activity and wanted to reach out to
                    discuss your progress. Let's schedule a time to connect."
                  </p>
                </div>
              </div>

              {/* Footer */}
              <div className="flex gap-3 p-6 border-t border-gray-100" data-id="element-406" data-mp="3h68u7pzaca0e">
                <button onClick={() => setMessageModal({
              isOpen: false,
              item: null
            })} className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium" data-id="element-407" data-mp="3h8bqgrr16zdk">
                  Cancel
                </button>
                <button onClick={() => setMessageModal({
              isOpen: false,
              item: null
            })} className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-[#DB3725] text-white rounded-lg hover:bg-[#c02f1f] transition-colors font-medium" data-id="element-408" data-mp="1dhe3fmovxwd0">
                  <Send size={18} data-id="element-409" data-mp="uqwelt76bkwx" />
                  Send
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* Meeting Modal */}
      <AnimatePresence data-id="element-410" data-mp="22ien7wiyeiq">
        {meetingModal.isOpen && meetingModal.item && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={() => setMeetingModal({
        isOpen: false,
        item: null
      })} data-id="element-411" data-mp="20ebwtad3lk1">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-white rounded-xl shadow-2xl max-w-lg w-full" onClick={e => e.stopPropagation()} data-id="element-412" data-mp="3gpeftxyhw04i">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-413" data-mp="2oz08kkkzlm1t">
                <div className="flex items-center gap-3" data-id="element-414" data-mp="gq235ts47nnp">
                  <div className="w-12 h-12 rounded-lg bg-[#30718D] flex items-center justify-center" data-id="element-415" data-mp="gqlg0w2wrluv">
                    <Video size={24} className="text-white" data-id="element-416" data-mp="lode67u5c47i" />
                  </div>
                  <h2 className="text-xl font-bold text-gray-900" data-id="element-417" data-mp="6rcm2381m78i">
                    Schedule Meeting
                  </h2>
                </div>
                <button onClick={() => setMeetingModal({
              isOpen: false,
              item: null
            })} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-418" data-mp="3u4ye6z4svmyh">
                  <X size={20} className="text-gray-500" data-id="element-419" data-mp="3p5lsihpo0lxh" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6" data-id="element-420" data-mp="3b7dr9xlliygi">
                <p className="text-gray-600 mb-1" data-id="element-421" data-mp="3b8gg7zzcyqts">Schedule a meeting with</p>
                <p className="text-lg font-bold text-gray-900 mb-6" data-id="element-422" data-mp="3f75zg972v2lc">
                  {getRecipientName(meetingModal.item)}
                </p>

                <div className="space-y-4" data-id="element-423" data-mp="2rkkbo6uclskf">
                  <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-424" data-mp="2rlvdi148gq8w">
                    <p className="text-sm text-gray-500 mb-2" data-id="element-425" data-mp="35l4x7arne2hm">Meeting Topic:</p>
                    <p className="text-gray-700 font-medium" data-id="element-426" data-mp="30kpj2gzjkqyl">
                      {meetingModal.item.insight}
                    </p>
                  </div>

                  <div className="grid grid-cols-2 gap-4" data-id="element-427" data-mp="3ffws26tuib8p">
                    <div data-id="element-428" data-mp="3aiddt6x5dygr">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-429" data-mp="3ah2b7affuwr8">
                        Date
                      </label>
                      <input type="date" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#30718D] focus:border-transparent" defaultValue={new Date().toISOString().split('T')[0]} data-id="element-430" data-mp="3k8g7l9c3fgg5" />
                    </div>
                    <div data-id="element-431" data-mp="9lf9b1b6pi0f">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-432" data-mp="9otdmf3es1ai">
                        Time
                      </label>
                      <input type="time" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#30718D] focus:border-transparent" defaultValue="10:00" data-id="element-433" data-mp="jk4rywawn6hq" />
                    </div>
                  </div>

                  <div data-id="element-434" data-mp="3i4mskpi3d4pg">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-435" data-mp="3i0yy9o4toe9o">
                      Duration
                    </label>
                    <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-436" data-mp="3rzy8hb58khys">
                      <option data-id="element-437" data-mp="3492b7yi0guk5">15 minutes</option>
                      <option selected data-id="element-438" data-mp="2zb96l9wcw8lz">30 minutes</option>
                      <option data-id="element-439" data-mp="1eu9r7h4b3qbe">45 minutes</option>
                      <option data-id="element-440" data-mp="1ethug2yz3mjj">1 hour</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="flex gap-3 p-6 border-t border-gray-100" data-id="element-441" data-mp="14wluiln548ql">
                <button onClick={() => setMeetingModal({
              isOpen: false,
              item: null
            })} className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium" data-id="element-442" data-mp="14u93lizemo1e">
                  Cancel
                </button>
                <button onClick={() => setMeetingModal({
              isOpen: false,
              item: null
            })} className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-[#DB3725] text-white rounded-lg hover:bg-[#c02f1f] transition-colors font-medium" data-id="element-443" data-mp="1slejfy5chgbp">
                  <Calendar size={18} data-id="element-444" data-mp="2eud8ssqlrnl3" />
                  Schedule
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* Kudos Modal */}
      <AnimatePresence data-id="element-445" data-mp="255219ajd6qzb">
        {kudosModal.isOpen && kudosModal.item && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={() => setKudosModal({
        isOpen: false,
        item: null
      })} data-id="element-446" data-mp="212ossed8geyu">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-white rounded-xl shadow-2xl max-w-lg w-full" onClick={e => e.stopPropagation()} data-id="element-447" data-mp="3lhquodxdqurr">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-448" data-mp="3623kig5e4jh5">
                <div className="flex items-center gap-3" data-id="element-449" data-mp="3a2nh9im1xl2r">
                  <div className="w-12 h-12 rounded-lg bg-[#007558] flex items-center justify-center" data-id="element-450" data-mp="3a59plkgro4m1">
                    <ThumbsUp size={24} className="text-white" data-id="element-451" data-mp="3f4cwlagb4kwn" />
                  </div>
                  <h2 className="text-xl font-bold text-gray-900" data-id="element-452" data-mp="3k2o61k2owtec">
                    Give Kudos
                  </h2>
                </div>
                <button onClick={() => setKudosModal({
              isOpen: false,
              item: null
            })} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-453" data-mp="zavuy5a8qi8h">
                  <X size={20} className="text-gray-500" data-id="element-454" data-mp="2h9aa8u8h1rky" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6" data-id="element-455" data-mp="2c84eenjilo77">
                <p className="text-gray-600 mb-1" data-id="element-456" data-mp="2cc0j9a5fp7v0">Send kudos to celebrate</p>
                <p className="text-lg font-bold text-gray-900 mb-6" data-id="element-457" data-mp="2r53wj5bzszfx">
                  {getRecipientName(kudosModal.item)}
                </p>

                <div className="bg-[#007558]/5 rounded-lg p-4 border border-[#007558]/20 mb-4" data-id="element-458" data-mp="2zzrz2nq6o311">
                  <div className="flex items-center gap-2 mb-2" data-id="element-459" data-mp="2vx51s7aqtpwg">
                    <Star size={18} className="text-[#007558]" data-id="element-460" data-mp="2vzrj2ynfrjrv" />
                    <p className="text-sm font-medium text-[#007558]" data-id="element-461" data-mp="39y7q6qp7ncaj">
                      Achievement:
                    </p>
                  </div>
                  <p className="text-gray-700" data-id="element-462" data-mp="3ok51w3w3ww17">{kudosModal.item.insight}</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-463" data-mp="3tj7vms6mzftv">
                  <p className="text-sm text-gray-500 mb-2" data-id="element-464" data-mp="3tgvj4ujndxo7">Kudos Message:</p>
                  <p className="text-gray-700 leading-relaxed" data-id="element-465" data-mp="3elpbk34wlqsr">
                    "Congratulations {getRecipientFirstName(kudosModal.item)}!
                    🎉 Your hard work and dedication have really paid off. Keep
                    up the amazing work!"
                  </p>
                </div>

                <div className="mt-4" data-id="element-466" data-mp="3amgil0hotwy9">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-467" data-mp="2vvziplkpbf3h">
                    Add a personal note (optional)
                  </label>
                  <textarea className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#007558] focus:border-transparent resize-none" rows={3} placeholder="Add your personal message..." data-id="element-468" data-mp="30sg6genznrg1" />
                </div>
              </div>

              {/* Footer */}
              <div className="flex gap-3 p-6 border-t border-gray-100" data-id="element-469" data-mp="slw4lt0kttrf">
                <button onClick={() => setKudosModal({
              isOpen: false,
              item: null
            })} className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium" data-id="element-470" data-mp="nnb4rup8lc3i">
                  Cancel
                </button>
                <button onClick={() => setKudosModal({
              isOpen: false,
              item: null
            })} className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-[#DB3725] text-white rounded-lg hover:bg-[#c02f1f] transition-colors font-medium" data-id="element-471" data-mp="16dkerqr9m85r">
                  <ThumbsUp size={18} data-id="element-472" data-mp="22lq9omd0n5rp" />
                  Send Kudos
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* Skill Filter Indicator */}
      {selectedSkill !== 'All Skills Combined'}

      {/* Summary Cards */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 mb-6" data-id="element-473" data-mp="2gddg3f0o9uo7">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-474" data-mp="2lby5skiasvye">
          <div className="flex items-center justify-between mb-3" data-id="element-475" data-mp="2za4xfiwnlzpm">
            <div className="w-12 h-12 rounded-lg bg-[#DB3725]/10 flex items-center justify-center" data-id="element-476" data-mp="zybwxcanqc85">
              <AlertTriangle size={24} className="text-[#DB3725]" data-id="element-477" data-mp="14wwuf3yiyhsw" />
            </div>
            <span className="text-3xl font-bold text-[#DB3725]" data-id="element-478" data-mp="36upa7aup1459">
              {urgentCount}
            </span>
          </div>
          <div className="text-sm font-medium text-gray-900" data-id="element-479" data-mp="32twzed66ar6v">
            Urgent Actions
          </div>
          <div className="text-xs text-gray-500 mt-1" data-id="element-480" data-mp="3gks0h3afk3zw">
            Require immediate attention
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-481" data-mp="3blyudvxh3f9r">
          <div className="flex items-center justify-between mb-3" data-id="element-482" data-mp="2xro4hb9qpf24">
            <div className="w-12 h-12 rounded-lg bg-yellow-100 flex items-center justify-center" data-id="element-483" data-mp="2stcu8zfj92jd">
              <Clock size={24} className="text-yellow-600" data-id="element-484" data-mp="d28fmlu300f4" />
            </div>
            <span className="text-3xl font-bold text-yellow-600" data-id="element-485" data-mp="83ng6omnlkrq">
              {attentionCount}
            </span>
          </div>
          <div className="text-sm font-medium text-gray-900" data-id="element-486" data-mp="1q10lzdjiofol">
            Needs Attention
          </div>
          <div className="text-xs text-gray-500 mt-1" data-id="element-487" data-mp="1uzbtviq94g46">Monitor and support</div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-488" data-mp="1h3q9xpyvkmim">
          <div className="flex items-center justify-between mb-3" data-id="element-489" data-mp="200j21iwb3hbd">
            <div className="w-12 h-12 rounded-lg bg-[#007558]/10 flex items-center justify-center" data-id="element-490" data-mp="2009d7ymzzg79">
              <Star size={24} className="text-[#007558]" data-id="element-491" data-mp="24xrjfh9mrhbk" />
            </div>
            <span className="text-3xl font-bold text-[#007558]" data-id="element-492" data-mp="2soexkka5336k">
              {celebrateCount}
            </span>
          </div>
          <div className="text-sm font-medium text-gray-900" data-id="element-493" data-mp="2xhzyol714d9z">
            Celebrate Success
          </div>
          <div className="text-xs text-gray-500 mt-1" data-id="element-494" data-mp="38p8vm1lkdb2">
            Recognize achievements
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-495" data-mp="czte3u1h0jsp">
          <div className="flex items-center justify-between mb-3" data-id="element-496" data-mp="3lh6e08cr8mfr">
            <div className="w-12 h-12 rounded-lg bg-[#30718D]/10 flex items-center justify-center" data-id="element-497" data-mp="3phzxmpj5zf2u">
              <CheckCircle size={24} className="text-[#30718D]" data-id="element-498" data-mp="3ugkxgnui7wqr" />
            </div>
            <span className="text-3xl font-bold text-[#30718D]" data-id="element-499" data-mp="14rj207tiw03x">
              {skillFilteredItems.length}
            </span>
          </div>
          <div className="text-sm font-medium text-gray-900" data-id="element-500" data-mp="19pkkaqj4jvec">Total Actions</div>
          <div className="text-xs text-gray-500 mt-1" data-id="element-501" data-mp="1jv28vhq5dmwp">
            {selectedSkill === 'All Skills Combined' ? 'All recommended items' : `For ${selectedSkill}`}
          </div>
        </motion.div>
      </div>

      {/* Filter Bar */}
      <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 mb-6" data-id="element-502" data-mp="1a2musvhz1ih3">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4 mb-4" data-id="element-503" data-mp="162vvu4iajw1h">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2" data-id="element-504" data-mp="111ye1t17140i">
            <div className="flex items-center gap-2" data-id="element-505" data-mp="w3n47iawetia">
              <Filter size={18} className="text-gray-600" data-id="element-506" data-mp="r53fxb8u15mr" />
              <span className="text-sm font-medium text-gray-700" data-id="element-507" data-mp="r7ok46wlrxno">
                Filter by:
              </span>
            </div>
            <div className="flex items-center gap-2 flex-wrap" data-id="element-508" data-mp="2lked8mf5d2u0">
              <button onClick={() => setActiveFilter('all')} className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${activeFilter === 'all' ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-509" data-mp="2lhjv51jlvu3r">
                All ({skillFilteredItems.length})
              </button>
              <button onClick={() => setActiveFilter('urgent')} className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${activeFilter === 'urgent' ? 'bg-[#DB3725] text-white' : 'bg-[#DB3725]/10 text-[#DB3725] hover:bg-[#DB3725]/20'}`} data-id="element-510" data-mp="5w8uysouvtzp">
                Urgent ({urgentCount})
              </button>
              <button onClick={() => setActiveFilter('attention')} className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${activeFilter === 'attention' ? 'bg-yellow-600 text-white' : 'bg-yellow-50 text-yellow-700 hover:bg-yellow-100'}`} data-id="element-511" data-mp="olp7kedtfcwh">
                Needs Attention ({attentionCount})
              </button>
              <button onClick={() => setActiveFilter('celebrate')} className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${activeFilter === 'celebrate' ? 'bg-[#007558] text-white' : 'bg-[#007558]/10 text-[#007558] hover:bg-[#007558]/20'}`} data-id="element-512" data-mp="3e8ehy8dqsj21">
                Celebrate ({celebrateCount})
              </button>
            </div>
          </div>
          <div className="flex items-center gap-2" data-id="element-513" data-mp="2n38uu8a8s6ls">
            <span className="text-sm font-medium text-gray-700" data-id="element-514" data-mp="2n40txt31smgt">View:</span>
            <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-1 flex-wrap" data-id="element-515" data-mp="2i4xm60voo255">
              <button onClick={() => setViewType('all')} className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all ${viewType === 'all' ? 'bg-white shadow-sm text-gray-900' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-516" data-mp="2wtkcsyqrggbo">
                All
              </button>
              <button onClick={() => setViewType('individual')} className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all ${viewType === 'individual' ? 'bg-white shadow-sm text-gray-900' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-517" data-mp="1zcn0fjt5uku9">
                Individual ({individualCount})
              </button>
              <button onClick={() => setViewType('macro')} className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all ${viewType === 'macro' ? 'bg-white shadow-sm text-gray-900' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-518" data-mp="1gdo8in2j2m2b">
                System-Wide ({macroCount})
              </button>
            </div>
          </div>
        </div>
        <div className="text-sm text-gray-600" data-id="element-519" data-mp="1v948t9tpbe75">
          Showing {filteredItems.length} of {skillFilteredItems.length} items
          {selectedSkill !== 'All Skills Combined' && ` (filtered by ${selectedSkill})`}
        </div>
      </div>

      {/* Action Items List */}
      <div className="space-y-4" data-id="element-520" data-mp="4ystgzzyyil8">
        <AnimatePresence mode="popLayout" data-id="element-521" data-mp="3tk4er92jud70">
          {filteredItems.map((item, index) => <motion.div key={item.id} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95
        }} transition={{
          delay: index * 0.05
        }} className="bg-white rounded-xl p-4 sm:p-6 shadow-sm border border-gray-200" data-id="element-522" data-mp="3otnxfdvly7fd" data-mpi={index}>
              {/* Header Row - Stack on mobile */}
              <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between mb-1 gap-2" data-id="element-523" data-mp="7fai3if8fh10">
                <div className="flex items-center gap-4" data-id="element-524" data-mp="2g7b3sfoz0qe">
                  {/* Icon */}
                  <div className={`flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center ${item.priority === 'high' ? 'bg-[#DB3725]/10 border-2 border-[#DB3725]' : item.priority === 'medium' ? 'bg-[#F59E0B]/10 border-2 border-[#F59E0B]' : 'bg-[#007558]/10 border-2 border-[#007558]'}`} data-id="element-525" data-mp="2s4q5s4j5mpmf">
                    {item.priority === 'high' ? <AlertTriangle size={20} className="text-[#DB3725] sm:w-6 sm:h-6" data-id="element-526" data-mp="2fmvt2303nr4p" /> : item.priority === 'medium' ? <Clock size={20} className="text-[#F59E0B] sm:w-6 sm:h-6" data-id="element-527" data-mp="2alpxzyiyvrs0" /> : <Star size={20} className="text-[#007558] sm:w-6 sm:h-6" data-id="element-528" data-mp="1vuquh1wzntfa" />}
                  </div>

                  {/* Name and Badge */}
                  <div data-id="element-529" data-mp="1rvqedr5wb4vz">
                    <div className="flex items-center gap-2 sm:gap-3 flex-wrap" data-id="element-530" data-mp="1ru6y40k8otu7">
                      <h4 className="text-base sm:text-lg font-semibold text-gray-900" data-id="element-531" data-mp="188x14724eb32">
                        {item.learner ? item.learner.name : 'System Alert'}
                      </h4>
                      <span className={`px-2 sm:px-3 py-1 rounded text-xs font-semibold ${item.priority === 'high' ? 'bg-[#DB3725] text-white' : item.priority === 'medium' ? 'bg-white text-gray-900 border border-gray-900' : 'bg-white text-gray-900 border border-gray-900'}`} data-id="element-532" data-mp="1hamon1svspvk">
                        {item.priority === 'high' ? 'Urgent' : item.priority === 'medium' ? 'Attention' : 'Celebrate'}
                      </span>
                    </div>
                    {item.learner && <p className="text-sm text-gray-500 mt-0.5 hidden sm:block" data-id="element-533" data-mp="29zbqx45ob18w">
                        {item.learner.email}
                      </p>}
                    {item.type === 'macro' && <p className="text-sm text-gray-500 mt-0.5" data-id="element-534" data-mp="3cehi5g66i0y4">
                        {item.affectedLearners} learners affected
                      </p>}
                  </div>
                </div>

                {/* Module and Time - Below name on mobile */}
                <div className="text-left sm:text-right ml-14 sm:ml-0" data-id="element-535" data-mp="3q9tokktp5fuv">
                  <p className="font-semibold text-gray-900 text-sm sm:text-base" data-id="element-536" data-mp="2tmyf59c5mmw3">
                    {item.module}
                  </p>
                  <p className="text-xs sm:text-sm text-gray-500" data-id="element-537" data-mp="2xkw4qd9u7b00">
                    {item.lastActivity}
                  </p>
                </div>
              </div>

              {/* Insight */}
              <div className="flex items-start gap-2 mt-4 mb-2" data-id="element-538" data-mp="37ewmpfq7waq5">
                <Zap size={18} className="text-gray-700 mt-0.5 flex-shrink-0" data-id="element-539" data-mp="29x4tze3y360u" />
                <p className="font-semibold text-gray-900" data-id="element-540" data-mp="2evplmp54shdo">{item.insight}</p>
              </div>

              {/* Details */}
              <p className="text-sm text-gray-600 ml-6 mb-5 leading-relaxed" data-id="element-541" data-mp="27cgmrpu9412v">
                {item.details}
              </p>

              {/* Suggested Actions */}
              <div className="mb-5" data-id="element-542" data-mp="1xe0vnmv84rtd">
                <p className="text-sm font-semibold text-gray-700 mb-3" data-id="element-543" data-mp="1xh56h3372lt0">
                  Suggested Actions
                </p>
                <div className="flex flex-wrap gap-2" data-id="element-544" data-mp="1oe40r3i8qwpv">
                  {item.suggestedActions.map((action, idx) => <span key={idx} className="px-4 py-2 bg-gray-100 text-gray-800 rounded text-sm font-medium border border-gray-200" data-id="element-545" data-mp="1jndu7my2wntl" data-mpi={idx}>
                      {action}
                    </span>)}
                </div>
              </div>

              {/* Action Buttons - Wrap on mobile */}
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 pt-5 border-t border-gray-200" data-id="element-546" data-mp="10otbai6ccor1">
                <div className="flex flex-wrap items-center gap-2 sm:gap-3" data-id="element-547" data-mp="1fb1ygmdbcfwa">
                  <button onClick={() => setMessageModal({
                isOpen: true,
                item
              })} className="flex items-center gap-2 px-3 sm:px-5 py-2 sm:py-2.5 bg-[#DB3725] text-white rounded-lg hover:bg-[#c02f1f] transition-all text-sm font-medium" data-id="element-548" data-mp="1abp3tfg7a4j5">
                    <Mail size={16} data-id="element-549" data-mp="1tz670xinjb1c" />
                    <span className="hidden sm:inline" data-id="element-550" data-mp="1u0zicq47mjfo">Send Message</span>
                  </button>
                  <button onClick={() => setMeetingModal({
                isOpen: true,
                item
              })} className="flex items-center gap-2 px-3 sm:px-5 py-2 sm:py-2.5 border border-gray-300 bg-white text-gray-700 rounded-lg hover:bg-gray-50 transition-all text-sm font-medium" data-id="element-551" data-mp="1p7eqlft7mlox">
                    <Video size={16} data-id="element-552" data-mp="2kc1ie74bbr9a" />
                    <span className="hidden sm:inline" data-id="element-553" data-mp="2p801bf6vgh2b">Schedule Meeting</span>
                  </button>
                  {item.priority === 'positive' && <button onClick={() => setKudosModal({
                isOpen: true,
                item
              })} className="flex items-center gap-2 px-3 sm:px-5 py-2 sm:py-2.5 border border-[#007558] bg-[#007558]/10 text-[#007558] rounded-lg hover:bg-[#007558]/20 transition-all text-sm font-medium" data-id="element-554" data-mp="2ua8x0jb4px84">
                      <ThumbsUp size={16} data-id="element-555" data-mp="3hw5n859nwc3q" />
                      <span className="hidden sm:inline" data-id="element-556" data-mp="3hz9y1lhmu63d">Send Kudos</span>
                    </button>}
                </div>
                <button className="text-sm font-medium text-gray-500 hover:text-gray-700 transition-colors self-start sm:self-auto" data-id="element-557" data-mp="3qz6sy4um816v">
                  Dismiss
                </button>
              </div>
            </motion.div>)}
        </AnimatePresence>
      </div>
    </div>;
}
function AggregateView({
  totalLearners,
  totalAssessments,
  overallAvgScore,
  overallMastery,
  moduleData,
  scoreDistribution,
  attemptTrends,
  COLORS,
  selectedSkill,
  setSelectedSkill,
  isSkillDropdownOpen,
  setIsSkillDropdownOpen,
  skillDropdownRef,
  skillOptions,
  selectedLearner,
  setSelectedLearner,
  selectedLearnerData,
  isLearnerDropdownOpen,
  setIsLearnerDropdownOpen,
  learnerDropdownRef
}) {
  const [selectedInsightSkill, setSelectedInsightSkill] = useState<string>('All Skills Combined');
  const [isInsightSkillDropdownOpen, setIsInsightSkillDropdownOpen] = useState(false);
  const insightSkillDropdownRef = useRef<HTMLDivElement>(null);
  const [selectedLeaderboardSkill, setSelectedLeaderboardSkill] = useState<string>('All Skills Combined');
  const [isLeaderboardSkillDropdownOpen, setIsLeaderboardSkillDropdownOpen] = useState(false);
  const leaderboardSkillDropdownRef = useRef<HTMLDivElement>(null);
  const [selectedLeaderboardMetric, setSelectedLeaderboardMetric] = useState<string>('Average Score');
  const [isLeaderboardMetricDropdownOpen, setIsLeaderboardMetricDropdownOpen] = useState(false);
  const leaderboardMetricDropdownRef = useRef<HTMLDivElement>(null);
  const [performanceLearnerFilter, setPerformanceLearnerFilter] = useState<string>('All Learners');
  const [performanceLearnerSearch, setPerformanceLearnerSearch] = useState<string>('');
  const [isPerformanceLearnerDropdownOpen, setIsPerformanceLearnerDropdownOpen] = useState(false);
  const performanceLearnerDropdownRef = useRef<HTMLDivElement>(null);
  const [performanceSortKey, setPerformanceSortKey] = useState<PerformanceTableSortKey>('confidentIncorrect');
  const [performanceSortDir, setPerformanceSortDir] = useState<'asc' | 'desc'>('desc');
  const [performancePage, setPerformancePage] = useState(1);
  const [isPerformancePageDropdownOpen, setIsPerformancePageDropdownOpen] = useState(false);
  const performancePageDropdownRef = useRef<HTMLDivElement>(null);
  const performancePerPage = 10;
  const handlePerformanceSort = (key: PerformanceTableSortKey) => {
    if (performanceSortKey === key) {
      setPerformanceSortDir(performanceSortDir === 'asc' ? 'desc' : 'asc');
    } else {
      setPerformanceSortKey(key);
      setPerformanceSortDir('asc');
    }
    setPerformancePage(1);
  };
  const [selectedChartType, setSelectedChartType] = useState<string>('Score Distribution');
  const [isChartTypeDropdownOpen, setIsChartTypeDropdownOpen] = useState(false);
  const chartTypeDropdownRef = useRef<HTMLDivElement>(null);
  const chartTypeOptions = ['Score Distribution', 'Performance by Attempt', 'Answer Confidence Breakdown'];
  const chartAreaRef = useRef<HTMLDivElement>(null);
  const handleDownloadChart = () => {
    if (!chartAreaRef.current) return;
    const svgElement = chartAreaRef.current.querySelector('svg');
    if (!svgElement) return;
    const svgClone = svgElement.cloneNode(true) as SVGElement;
    // Ensure the SVG has explicit dimensions
    const bbox = svgElement.getBoundingClientRect();
    svgClone.setAttribute('width', String(bbox.width));
    svgClone.setAttribute('height', String(bbox.height));
    svgClone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svgClone);
    const svgBlob = new Blob([svgString], {
      type: 'image/svg+xml;charset=utf-8'
    });
    const url = URL.createObjectURL(svgBlob);
    const canvas = document.createElement('canvas');
    const scale = 2; // retina quality
    canvas.width = bbox.width * scale;
    canvas.height = bbox.height * scale;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const img = new Image();
    img.onload = () => {
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.scale(scale, scale);
      ctx.drawImage(img, 0, 0);
      URL.revokeObjectURL(url);
      const pngUrl = canvas.toDataURL('image/png');
      const downloadLink = document.createElement('a');
      downloadLink.href = pngUrl;
      downloadLink.download = `${selectedChartType.replace(/\s+/g, '_')}_chart.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    };
    img.src = url;
  };
  // Local learner state for Data Explorer (doesn't switch to IndividualView)
  const [selectedChartLearner, setSelectedChartLearner] = useState<number | null>(null);
  const [isChartLearnerDropdownOpen, setIsChartLearnerDropdownOpen] = useState(false);
  const chartLearnerDropdownRef = useRef<HTMLDivElement>(null);
  const selectedChartLearnerData = selectedChartLearner ? mockLearners.find(l => l.id === selectedChartLearner) : null;
  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (insightSkillDropdownRef.current && !insightSkillDropdownRef.current.contains(event.target as Node)) {
        setIsInsightSkillDropdownOpen(false);
      }
      if (leaderboardSkillDropdownRef.current && !leaderboardSkillDropdownRef.current.contains(event.target as Node)) {
        setIsLeaderboardSkillDropdownOpen(false);
      }
      if (leaderboardMetricDropdownRef.current && !leaderboardMetricDropdownRef.current.contains(event.target as Node)) {
        setIsLeaderboardMetricDropdownOpen(false);
      }
      if (chartTypeDropdownRef.current && !chartTypeDropdownRef.current.contains(event.target as Node)) {
        setIsChartTypeDropdownOpen(false);
      }
      if (chartLearnerDropdownRef.current && !chartLearnerDropdownRef.current.contains(event.target as Node)) {
        setIsChartLearnerDropdownOpen(false);
      }
      if (performanceLearnerDropdownRef.current && !performanceLearnerDropdownRef.current.contains(event.target as Node)) {
        setIsPerformanceLearnerDropdownOpen(false);
      }
      if (performancePageDropdownRef.current && !performancePageDropdownRef.current.contains(event.target as Node)) {
        setIsPerformancePageDropdownOpen(false);
      }
    };
    if (isInsightSkillDropdownOpen || isLeaderboardSkillDropdownOpen || isLeaderboardMetricDropdownOpen || isChartTypeDropdownOpen || isChartLearnerDropdownOpen || isPerformanceLearnerDropdownOpen || isPerformancePageDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isInsightSkillDropdownOpen, isLeaderboardSkillDropdownOpen, isLeaderboardMetricDropdownOpen, isChartTypeDropdownOpen, isChartLearnerDropdownOpen, isPerformanceLearnerDropdownOpen, isPerformancePageDropdownOpen]);
  // Filter module data based on selected skill
  const filteredModuleData = selectedSkill === 'All Skills Combined' ? moduleData : moduleData.filter(m => m.module === selectedSkill);
  // Filter module data for insight cards based on local insight skill selector
  const insightFilteredModuleData = selectedInsightSkill === 'All Skills Combined' ? moduleData : moduleData.filter(m => m.module === selectedInsightSkill);
  // Calculate insight-filtered metrics
  const insightFilteredAvgScore = insightFilteredModuleData.length > 0 ? Math.round(insightFilteredModuleData.reduce((sum, m) => sum + m.avgScore, 0) / insightFilteredModuleData.length) : 0;
  const insightFilteredAttempts = insightFilteredModuleData.reduce((sum, m) => sum + m.attempts, 0);
  // Calculate filtered metrics
  const filteredAvgScore = filteredModuleData.length > 0 ? Math.round(filteredModuleData.reduce((sum, m) => sum + m.avgScore, 0) / filteredModuleData.length) : 0;
  const filteredMastery = filteredModuleData.length > 0 ? Math.round(filteredModuleData.reduce((sum, m) => sum + m.mastery, 0) / filteredModuleData.length) : 0;
  const filteredAttempts = filteredModuleData.reduce((sum, m) => sum + m.attempts, 0);
  // Filter score distribution based on skill (simulated - in real app this would come from backend)
  const filteredScoreDistribution = selectedSkill === 'All Skills Combined' ? scoreDistribution : scoreDistribution.map(item => ({
    ...item,
    count: Math.round(item.count * (filteredModuleData.length / moduleData.length))
  }));
  // Skill Performance header controls
  const [skillPerfTimeRange, setSkillPerfTimeRange] = useState<30 | 60 | 90>(30);
  const [skillPerfLastUpdated, setSkillPerfLastUpdated] = useState<Date>(new Date());
  const [isSkillPerfRefreshing, setIsSkillPerfRefreshing] = useState(false);
  const [isTimeRangeDropdownOpen, setIsTimeRangeDropdownOpen] = useState(false);
  const timeRangeDropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (timeRangeDropdownRef.current && !timeRangeDropdownRef.current.contains(event.target as Node)) {
        setIsTimeRangeDropdownOpen(false);
      }
    };
    if (isTimeRangeDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isTimeRangeDropdownOpen]);
  const handleSkillPerfRefresh = () => {
    setIsSkillPerfRefreshing(true);
    setTimeout(() => {
      setSkillPerfLastUpdated(new Date());
      setIsSkillPerfRefreshing(false);
    }, 800);
  };
  const formatRelativeTime = (date: Date) => {
    const diffSec = Math.floor((Date.now() - date.getTime()) / 1000);
    if (diffSec < 60) return 'Just now';
    const diffMin = Math.floor(diffSec / 60);
    if (diffMin < 60) return `${diffMin} minute${diffMin === 1 ? '' : 's'} ago`;
    const diffHr = Math.floor(diffMin / 60);
    return `${diffHr} hour${diffHr === 1 ? '' : 's'} ago`;
  };
  return <>
      {/* Aggregate Data Across All Assessments */}

      {/* Assessment Insights */}
      <div data-phoebe-tour="analytics-summary" className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-visible mb-6" data-id="element-558" data-mp="2x6wt7uuigmlj">
        {/* Assessment Insights Header */}
        <div className="bg-white px-4 sm:px-6 py-5 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4" data-id="element-559" data-mp="ci8nvhv6df8g">
          <div data-id="element-560" data-mp="himwp24lot7j">
            <div className="flex items-center gap-2" data-id="element-561" data-mp="21yl0mpbq2mzv">
              <h4 className="text-base font-bold text-gray-900 mb-0.5 flex items-center gap-2" data-id="element-562" data-mp="21y1kne5mu8oh">
                <BarChart3 size={22} className="text-[#30718D]" data-id="element-563" data-mp="1x001kt87i9d0" />
                Skill Performance
              </h4>
              <AIInsightPopover align="left" headline="CSS Fundamentals is a priority support opportunity" insightBeforeMetric="CSS Fundamentals has a" highlightedMetric="22% misinformation rate" insightAfterMetric=", above the other core modules." explanation="Clearer practice around Flexbox, Grid, and positioning can improve readiness before the next assessment." insightId={8} data-id="element-564" data-mp="1s6ygg3hepdkz" />
            </div>
            <p className="text-sm text-gray-500 ml-[26px]" data-id="element-565" data-mp="33ny76uo3vkcw">
              {selectedInsightSkill === 'All Skills Combined' ? 'Detailed metrics for all skills' : `Detailed metrics for ${selectedInsightSkill}`}
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2" data-id="element-566" data-mp="36qb7j6oi7g0a">
            {/* Skill dropdown */}
            <div className="relative" ref={insightSkillDropdownRef} data-id="element-567" data-mp="3bnur8m3z0kzm">
              <button onClick={() => setIsInsightSkillDropdownOpen(!isInsightSkillDropdownOpen)} className="flex items-center gap-2 px-3 sm:px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white text-sm font-bold text-gray-900 w-full sm:min-w-[200px]" data-id="element-568" data-mp="2wqbyz9s33pnf">
                <Target size={16} className="text-[#30718D]" data-id="element-569" data-mp="2e143xta70086" />
                <span className="flex-1 text-left" data-id="element-570" data-mp="2dyrgx1pkuzo9">{selectedInsightSkill}</span>
                <ChevronDown size={16} className={`transition-transform text-gray-500 ${isInsightSkillDropdownOpen ? 'rotate-180' : ''}`} data-id="element-571" data-mp="2j0grkg8w1bbt" />
              </button>

              {isInsightSkillDropdownOpen && <div className="absolute top-full mt-2 right-0 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-10" data-id="element-572" data-mp="1qcz123njml72">
                  {skillOptions.map(skill => <button key={skill} onClick={() => {
                setSelectedInsightSkill(skill);
                setIsInsightSkillDropdownOpen(false);
              }} className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0 text-sm ${selectedInsightSkill === skill ? 'bg-[#30718D]/5 text-[#30718D] font-semibold' : 'text-gray-700'}`} data-id="element-573" data-mp="1zdx5gn1w8uq6">
                      {skill}
                    </button>)}
                </div>}
            </div>
            {/* Time range dropdown */}
            <div className="relative" ref={timeRangeDropdownRef} data-id="element-574" data-mp="2s0hsxcf90mog">
              <button onClick={() => setIsTimeRangeDropdownOpen(!isTimeRangeDropdownOpen)} className="flex items-center gap-2 px-3 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white text-sm font-semibold text-gray-900 min-w-[130px]" data-id="element-575" data-mp="2n5ayywbs6wcq">
                <Calendar size={14} className="text-[#30718D]" data-id="element-576" data-mp="1yhgj8yaqct1o" />
                <span className="flex-1 text-left" data-id="element-577" data-mp="1yjt9dyqn69pt">
                  Last {skillPerfTimeRange} days
                </span>
                <ChevronDown size={14} className={`transition-transform text-gray-500 ${isTimeRangeDropdownOpen ? 'rotate-180' : ''}`} data-id="element-578" data-mp="28fw80umabq80" />
              </button>
              {isTimeRangeDropdownOpen && <div className="absolute top-full mt-2 right-0 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-10" data-id="element-579" data-mp="2hg2jyc2c4i52">
                  {[30, 60, 90].map(range => <button key={range} onClick={() => {
                setSkillPerfTimeRange(range as 30 | 60 | 90);
                setIsTimeRangeDropdownOpen(false);
              }} className={`w-full px-4 py-2.5 text-left hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0 text-sm ${skillPerfTimeRange === range ? 'bg-[#30718D]/5 text-[#30718D] font-semibold' : 'text-gray-700'}`} data-id="element-580" data-mp="n3mg1hx0hg3d">
                      Last {range} days
                    </button>)}
                </div>}
            </div>
            {/* Last updated + Refresh button */}
          </div>
        </div>

        {/* Metrics Grid */}
        <div className="p-3 sm:p-6" data-id="element-581" data-mp="kieyaxzzyp1e">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-3 sm:mb-4" data-id="element-582" data-mp="khdgmaoh74ap">
            {/* Row 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6" data-id="element-583" data-mp="39bak6kvn061m">
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1 sm:mb-2" data-id="element-584" data-mp="z8d4rhodxnnb">
                Learners Attempted
              </div>
              <div className="text-2xl sm:text-4xl font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-585" data-mp="1rvz8cpxm4sa6">
                86
              </div>
              <div className="text-xs sm:text-sm text-gray-600 hidden sm:block mb-1 sm:mb-2" data-id="element-586" data-mp="1vw9bluu0t4lc">
                Total number of learners who attempted the assessment for skill
              </div>
              <div className="flex items-center gap-1.5 text-[#007558] text-xs sm:text-sm font-medium" data-id="element-587" data-mp="1n47i6gidcokk">
                <span className="text-[10px] sm:text-xs" data-id="element-588" data-mp="2atjwfusjzmtq">▲</span>
                <span data-id="element-589" data-mp="2fl1mvowya50g">
                  12%<span className="hidden sm:inline" data-id="element-590" data-mp="2fljv7jww09oq"> vs 30 days ago</span>
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.15
          }} className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6" data-id="element-591" data-mp="2oy0py6lb5b3j">
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1 sm:mb-2" data-id="element-592" data-mp="2620ycww8s9kh">
                Learners Passed
              </div>
              <div className="text-2xl sm:text-4xl font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-593" data-mp="2fz5mh29nef3x">
                85
              </div>
              <div className="text-xs sm:text-sm text-gray-600 hidden sm:block mb-1 sm:mb-2" data-id="element-594" data-mp="2azaqwlexh1cj">
                Number of learners who successfully passed the skill
              </div>
              <div className="flex items-center gap-1.5 text-[#007558] text-xs sm:text-sm font-medium" data-id="element-595" data-mp="3mgaj7h19zg6k">
                <span className="text-[10px] sm:text-xs" data-id="element-596" data-mp="uwdauiftidmk">▲</span>
                <span data-id="element-597" data-mp="zvq7fuwhqz2c">
                  14%<span className="hidden sm:inline" data-id="element-598" data-mp="zvzo2rvnbtvd"> vs 30 days ago</span>
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6" data-id="element-599" data-mp="l6jznijl80iu">
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1 sm:mb-2" data-id="element-600" data-mp="299cuxf56zka">
                Completion Rate
              </div>
              <div className="text-2xl sm:text-4xl font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-601" data-mp="1wlz4t9ly9yp1">
                98.33%
              </div>
              <div className="text-xs sm:text-sm text-gray-600 hidden sm:block mb-1 sm:mb-2" data-id="element-602" data-mp="21k0onwr7a21k">
                Percentage of learners who passed the assessment
              </div>
              <div className="flex items-center gap-1.5 text-[#007558] text-xs sm:text-sm font-medium" data-id="element-603" data-mp="3h4jh2ynsec0n">
                <span className="text-[10px] sm:text-xs" data-id="element-604" data-mp="3vtfjaf35wutc">▲</span>
                <span data-id="element-605" data-mp="3vuqs4tbgssrb">
                  3%<span className="hidden sm:inline" data-id="element-606" data-mp="3r1p8k80bc51e"> vs 30 days ago</span>
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.25
          }} className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6" data-id="element-607" data-mp="8mn1zbe8lz39">
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1 sm:mb-2" data-id="element-608" data-mp="2ketpk2apeabm">
                Avg. Number of Attempts
              </div>
              <div className="text-2xl sm:text-4xl font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-609" data-mp="jbj635dew5iz">
                3.78
              </div>
              <div className="text-xs sm:text-sm text-gray-600 hidden sm:block mb-1 sm:mb-2" data-id="element-610" data-mp="obnkmpureq6k">
                Average number of attempts per learner to complete the skill
              </div>
              <div className="flex items-center gap-1.5 text-[#DB3725] text-xs sm:text-sm font-medium" data-id="element-611" data-mp="xbkf583tyj9j">
                <span className="text-[10px] sm:text-xs" data-id="element-612" data-mp="12b6p98od3je4">▼</span>
                <span data-id="element-613" data-mp="179i0nnub21yg">
                  8%<span className="hidden sm:inline" data-id="element-614" data-mp="178osqjjm16eq"> vs 30 days ago</span>
                </span>
              </div>
            </motion.div>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4" data-id="element-615" data-mp="1c2b4m9hy969h">
            {/* Row 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6" data-id="element-616" data-mp="1g3morzi20zaa">
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1 sm:mb-2" data-id="element-617" data-mp="1v3ie78midq4p">
                Avg. Final Score
              </div>
              <div className="text-2xl sm:text-4xl font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-618" data-mp="1m4nbi6ioay65">
                92.25%
              </div>
              <div className="text-xs sm:text-sm text-gray-600 hidden sm:block mb-1 sm:mb-2" data-id="element-619" data-mp="2itw9d80e453i">
                Average final score achieved by all learners
              </div>
              <div className="flex items-center gap-1.5 text-[#007558] text-xs sm:text-sm font-medium" data-id="element-620" data-mp="293t9qoyrjsw7">
                <span className="text-[10px] sm:text-xs" data-id="element-621" data-mp="251y8fkgu1fif">▲</span>
                <span data-id="element-622" data-mp="31knefxdch9c3">
                  5%<span className="hidden sm:inline" data-id="element-623" data-mp="31l5mdr9ddbzu"> vs 30 days ago</span>
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.35
          }} className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6 overflow-visible" data-id="element-624" data-mp="2ws2mz2hwv8bq">
              <div className="flex items-start justify-between gap-2 mb-1 sm:mb-2" data-id="element-625" data-mp="2cdclhf65h95a">
                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide" data-id="element-626" data-mp="3036ypxudszq2">
                  Avg. First Score
                </div>
                <AIInsightPopover headline="First-attempt readiness needs attention" insightBeforeMetric="Average first-attempt score is" highlightedMetric="64.93%" insightAfterMetric=", below the 70% pass threshold." explanation="Target the concepts producing confident incorrect responses before learners begin another full assessment." insightId={9} data-id="element-627" data-mp="2ralfkgmu8r0p" />
              </div>
              <div className="text-2xl sm:text-4xl font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-628" data-mp="17efog5l0bass">
                64.93%
              </div>
              <div className="text-xs sm:text-sm text-gray-600 hidden sm:block mb-1 sm:mb-2" data-id="element-629" data-mp="1m20ry0lsnc18">
                Average score achieved on first attempt
              </div>
              <div className="flex items-center gap-1.5 text-[#DB3725] text-xs sm:text-sm font-medium" data-id="element-630" data-mp="te50pbezucbu">
                <span className="text-[10px] sm:text-xs" data-id="element-631" data-mp="oftm6ndr7dna">▼</span>
                <span data-id="element-632" data-mp="ohoa8akbnlvl">
                  3%<span className="hidden sm:inline" data-id="element-633" data-mp="13cb11ol5jael"> vs 30 days ago</span>
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4
          }} className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6" data-id="element-634" data-mp="ycohkxeqcxxc">
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1 sm:mb-2" data-id="element-635" data-mp="2lu4s8rd95n1t">
                Avg. Mastery Rate
              </div>
              <div className="text-2xl sm:text-4xl font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-636" data-mp="2qs6cvgqbtufe">
                65.52%
              </div>
              <div className="text-xs sm:text-sm text-gray-600 hidden sm:block mb-1 sm:mb-2" data-id="element-637" data-mp="1y64qkweekc8g">
                Average mastery rate across all attempts
              </div>
              <div className="flex items-center gap-1.5 text-[#007558] text-xs sm:text-sm font-medium" data-id="element-638" data-mp="283j70w0bt10r">
                <span className="text-[10px] sm:text-xs" data-id="element-639" data-mp="2cu9eqfw85fym">▲</span>
                <span data-id="element-640" data-mp="2cvkhccdxoho5">
                  7%<span className="hidden sm:inline" data-id="element-641" data-mp="1fevhgo8jnphe"> vs 30 days ago</span>
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.45
          }} className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6" data-id="element-642" data-mp="1kcx0j95yzosv">
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1 sm:mb-2" data-id="element-643" data-mp="3joyp8g7s3ilf">
                Avg. Misinfo Rate
              </div>
              <div className="text-2xl sm:text-4xl font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-644" data-mp="3ergp9fbqodpk">
                18.18%
              </div>
              <div className="text-xs sm:text-sm text-gray-600 hidden sm:block mb-1 sm:mb-2" data-id="element-645" data-mp="35wsjzp65yw0r">
                Average misinformation rate across all attempts
              </div>
              <div className="flex items-center gap-1.5 text-[#DB3725] text-xs sm:text-sm font-medium" data-id="element-646" data-mp="30w4l6hbp1avz">
                <span className="text-[10px] sm:text-xs" data-id="element-647" data-mp="2qzrrhjg5ex18">▼</span>
                <span data-id="element-648" data-mp="2r0b88wu2bfdo">
                  4%<span className="hidden sm:inline" data-id="element-649" data-mp="2r248nue313d8"> vs 30 days ago</span>
                </span>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Unified Data Explorer Section */}
      <div data-phoebe-tour="analytics-explorer" className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden mb-6" data-id="element-650" data-mp="9qwvuml8nrpy">
        {/* Section Header */}
        <div className="bg-white px-4 sm:px-6 py-5 border-b border-gray-200" data-id="element-651" data-mp="erktvs7vx8to">
          <h4 className="text-base font-bold text-gray-900 mb-0.5 flex items-center gap-2" data-id="element-652" data-mp="3w4eva3q2u09f">
            <TrendingUp size={22} className="text-[#30718D]" data-id="element-653" data-mp="4svdy4zjtyg2" />
            Data Explorer
          </h4>
          <p className="text-sm text-gray-500 ml-[26px]" data-id="element-654" data-mp="3n6uwd1fosg1z">
            Visualize and compare performance data across learners and skills
          </p>
        </div>
        {/* Header with Dropdowns */}
        <div className="p-3 sm:p-6 border-b border-gray-100 flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-4" data-id="element-655" data-mp="3d7nfw5dno5an">
          {/* Chart Type Dropdown */}
          <div className="relative flex-1" ref={chartTypeDropdownRef} data-id="element-656" data-mp="2ylgel5pmmget">
            <button onClick={() => {
            setIsChartTypeDropdownOpen(!isChartTypeDropdownOpen);
            setIsSkillDropdownOpen(false);
            setIsLearnerDropdownOpen(false);
          }} className="flex items-center justify-between px-4 py-2.5 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white w-full text-sm font-medium" data-id="element-657" data-mp="2uj3a0kmm8ojm">
              <div className="flex items-center gap-2" data-id="element-658" data-mp="3dih3z2kchza4">
                <BarChart3 size={18} className="text-[#30718D]" data-id="element-659" data-mp="3dfuxz7d3rru0" />
                <span className="text-left" data-id="element-660" data-mp="3r8kp1q7hnmxz">{selectedChartType}</span>
              </div>
              <ChevronDown size={16} className={`transition-transform ${isChartTypeDropdownOpen ? 'rotate-180' : ''}`} data-id="element-661" data-mp="3mbanxdaqlmub" />
            </button>

            {isChartTypeDropdownOpen && <div className="absolute top-full mt-2 left-0 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-10" data-id="element-662" data-mp="oodq1b4d1x">
                {chartTypeOptions.map(type => <button key={type} onClick={() => {
              setSelectedChartType(type);
              setIsChartTypeDropdownOpen(false);
            }} className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0 text-sm ${selectedChartType === type ? 'bg-[#30718D]/5 text-[#30718D] font-semibold' : 'text-gray-700'}`} data-id="element-663" data-mp="wiwps6q6wdxw">
                    {type}
                  </button>)}
              </div>}
          </div>

          {/* Skill Selector Dropdown */}
          <div className="relative flex-1" ref={skillDropdownRef} data-id="element-664" data-mp="3vx8p0zvdnhoo">
            <button onClick={() => {
            setIsSkillDropdownOpen(!isSkillDropdownOpen);
            setIsChartLearnerDropdownOpen(false);
            setIsChartTypeDropdownOpen(false);
          }} className="flex items-center justify-between px-4 py-2.5 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white w-full text-sm font-medium" data-id="element-665" data-mp="3vzl4n6dnxfyk">
              <div className="flex items-center gap-2" data-id="element-666" data-mp="2kg5wr4a2jq71">
                <Target size={18} className="text-[#30718D]" data-id="element-667" data-mp="2kfmcvi0uyrqd" />
                <span className="text-left" data-id="element-668" data-mp="1nqoezqxtadoz">{selectedSkill}</span>
              </div>
              <ChevronDown size={16} className={`transition-transform ${isSkillDropdownOpen ? 'rotate-180' : ''}`} data-id="element-669" data-mp="1soq7f2h4npd4" />
            </button>

            {isSkillDropdownOpen && <div className="absolute top-full mt-2 left-0 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-10" data-id="element-670" data-mp="21ibo4rcurgp6">
                {skillOptions.map(skill => <button key={skill} onClick={() => {
              setSelectedSkill(skill);
              setIsSkillDropdownOpen(false);
            }} className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0 text-sm ${selectedSkill === skill ? 'bg-[#30718D]/5 text-[#30718D] font-semibold' : 'text-gray-700'}`} data-id="element-671" data-mp="190qv3n6x0a5l">
                    {skill}
                  </button>)}
              </div>}
          </div>

          {/* Learner Dropdown */}
          <div className="relative flex-1" ref={chartLearnerDropdownRef} data-id="element-672" data-mp="1of93rrqusf3h">
            <button onClick={() => {
            setIsChartLearnerDropdownOpen(!isChartLearnerDropdownOpen);
            setIsSkillDropdownOpen(false);
            setIsChartTypeDropdownOpen(false);
          }} className="flex items-center justify-between px-4 py-2.5 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white w-full text-sm font-medium" data-id="element-673" data-mp="22e8ia6knjdlx">
              <div className="flex items-center gap-2" data-id="element-674" data-mp="3ha06tf3nic37">
                <Users size={18} className="text-[#30718D]" data-id="element-675" data-mp="3m9mpi4290kje" />
                <span className="text-left" data-id="element-676" data-mp="3mb7fdgdmbfax">
                  {selectedChartLearnerData ? selectedChartLearnerData.name : 'All Learners'}
                </span>
              </div>
              <ChevronDown size={16} className={`transition-transform ${isChartLearnerDropdownOpen ? 'rotate-180' : ''}`} data-id="element-677" data-mp="3vwxgwb2ic3p" />
            </button>

            {isChartLearnerDropdownOpen && <div className="absolute top-full mt-2 left-0 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-10 max-h-80 overflow-y-auto" data-id="element-678" data-mp="3qagb2qs7xn94">
                <button onClick={() => {
              setSelectedChartLearner(null);
              setIsChartLearnerDropdownOpen(false);
            }} className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors border-b border-gray-100 text-sm ${selectedChartLearner === null ? 'bg-[#30718D]/5 text-[#30718D] font-semibold' : 'text-gray-700'}`} data-id="element-679" data-mp="3v883dlwrzbdu">
                  All Learners
                </button>
                {[...mockLearners].sort((a, b) => {
              const lastNameA = a.name.split(' ').slice(-1)[0].toLowerCase();
              const lastNameB = b.name.split(' ').slice(-1)[0].toLowerCase();
              return lastNameA.localeCompare(lastNameB);
            }).map(learner => <button key={learner.id} onClick={() => {
              setSelectedChartLearner(learner.id);
              setIsChartLearnerDropdownOpen(false);
            }} className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0 ${selectedChartLearner === learner.id ? 'bg-[#30718D]/5' : ''}`} data-id="element-680" data-mp="3422sreviucuy">
                      <div className={`font-medium text-sm ${selectedChartLearner === learner.id ? 'text-[#30718D]' : 'text-gray-900'}`} data-id="element-681" data-mp="hv6agv0oy69s">
                        {learner.name}
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-682" data-mp="vwacrcbwmyjf">
                        {learner.email}
                      </div>
                    </button>)}
              </div>}
          </div>

          {/* Download Chart Button */}
          <button onClick={handleDownloadChart} className="px-4 py-2.5 rounded-lg text-sm font-medium transition-all relative flex items-center gap-2 bg-[#DB3725] text-white hover:bg-[#c02f1f] flex-shrink-0" data-id="element-683" data-mp="15lk8d25yizca">
            <Download size={16} data-id="element-684" data-mp="pvujk6ixoq7h" />
            <span data-id="element-685" data-mp="px5int1fp9s9">Download</span>
          </button>
        </div>

        {/* Chart Area */}
        <div className="p-3 sm:p-6" ref={chartAreaRef} data-id="element-686" data-mp="kylx3tqr600f">
          {selectedChartType === 'Score Distribution' && <div data-id="element-687" data-mp="zni3lmd5v4yx">
              <h3 className="text-sm sm:text-lg font-semibold mb-4 sm:mb-6" data-id="element-688" data-mp="zo08t8hswtiz">
                Score Distribution
                {selectedChartLearnerData ? ` - ${selectedChartLearnerData.name}` : ' - All Learners'}
                {selectedSkill !== 'All Skills Combined' ? ` - ${selectedSkill}` : ' - All Skills Combined'}
              </h3>
              <ResponsiveContainer width="100%" height={300} data-id="element-689" data-mp="1dlyja2t045t7">
                {(() => {
              // Simulated "other students" distribution for comparison
              const otherStudentsCounts = [3, 7, 12, 18, 10];
              const dataWithOthers = filteredScoreDistribution.map((d, i) => ({
                ...d,
                others: otherStudentsCounts[i] ?? Math.round(d.count * 0.8)
              }));
              return <ComposedChart data={dataWithOthers} margin={{
                top: 10,
                right: 10,
                left: -20,
                bottom: 0
              }} data-id="element-690" data-mp="1l4oaqfbuxg48">
                      <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" vertical={false} data-id="element-691" data-mp="1g760mlm3suun" />
                      <XAxis dataKey="range" axisLine={{
                  stroke: '#d1d5db'
                }} tickLine={false} tick={{
                  fill: '#6b7280',
                  fontSize: 12
                }} dy={10} data-id="element-692" data-mp="176rclehr91ng" />
                      <YAxis axisLine={false} tickLine={false} tick={{
                  fill: '#6b7280',
                  fontSize: 12
                }} data-id="element-693" data-mp="1kckmtov9ulp3" />
                      <Tooltip cursor={{
                  fill: 'rgba(0, 0, 0, 0.04)'
                }} contentStyle={{
                  backgroundColor: 'rgba(255, 255, 255, 0.95)',
                  borderRadius: '4px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
                  padding: '8px 12px'
                }} data-id="element-694" data-mp="15mn07dczq420" />
                      <Bar dataKey="count" name="Learners" fill="rgba(48, 113, 141, 0.5)" stroke="#30718D" strokeWidth={1} radius={[0, 0, 0, 0]} barSize={40} data-id="element-695" data-mp="2tknr2oh3tpll" />
                      <Line dataKey="others" name="Other Students" type="monotone" stroke="#7CB9E8" strokeWidth={2} dot={{
                  r: 4,
                  fill: '#fff',
                  stroke: '#7CB9E8',
                  strokeWidth: 2
                }} activeDot={{
                  r: 6,
                  fill: '#fff',
                  stroke: '#7CB9E8',
                  strokeWidth: 2
                }} data-id="element-696" data-mp="38b4u2c9e0nkl" />
                    </ComposedChart>;
            })()}
              </ResponsiveContainer>
            </div>}

          {selectedChartType === 'Performance by Attempt' && <div data-id="element-697" data-mp="dmxpb8pm2lxz">
              <h3 className="text-sm sm:text-lg font-semibold mb-4 sm:mb-6" data-id="element-698" data-mp="ijxuziijtmok">
                Performance by Attempt
                {selectedChartLearnerData ? ` - ${selectedChartLearnerData.name}` : ' - All Learners'}
                {selectedSkill !== 'All Skills Combined' ? ` - ${selectedSkill}` : ' - All Skills Combined'}
              </h3>
              <ResponsiveContainer width="100%" height={300} data-id="element-699" data-mp="3vzde7cv30w06">
                <AreaChart data={attemptTrends} margin={{
              top: 10,
              right: 10,
              left: -20,
              bottom: 0
            }} data-id="element-700" data-mp="3vwr7ffg0mkj0">
                  <defs data-id="element-701" data-mp="2vpm4urh5fc1x">
                    <linearGradient id="colorScore" x1="0" y1="0" x2="0" y2="1" data-id="element-702" data-mp="2vpvv8g63vl85">
                      <stop offset="5%" stopColor="rgba(48, 113, 141, 0.2)" stopOpacity={1} data-id="element-703" data-mp="2qsvmtylsa6dv" />
                      <stop offset="95%" stopColor="rgba(48, 113, 141, 0.0)" stopOpacity={1} data-id="element-704" data-mp="2h0pz512keb4h" />
                    </linearGradient>
                  </defs>
                  <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" vertical={false} data-id="element-705" data-mp="283fn3dhxahyi" />
                  <XAxis dataKey="attempt" axisLine={{
                stroke: '#d1d5db'
              }} tickLine={false} tick={{
                fill: '#6b7280',
                fontSize: 12
              }} dy={10} data-id="element-706" data-mp="1y4gaxkxy846r" />
                  <YAxis domain={[0, 100]} axisLine={false} tickLine={false} tick={{
                fill: '#6b7280',
                fontSize: 12
              }} data-id="element-707" data-mp="1viqpjjbxzwmu" />
                  <Tooltip contentStyle={{
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                borderRadius: '4px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
                padding: '8px 12px'
              }} data-id="element-708" data-mp="29ii35iyjrb0b" />
                  <Area type="monotone" dataKey="avgScore" stroke="#30718D" strokeWidth={2} fillOpacity={1} fill="url(#colorScore)" dot={{
                r: 4,
                fill: '#fff',
                stroke: '#30718D',
                strokeWidth: 2
              }} activeDot={{
                r: 6,
                fill: '#fff',
                stroke: '#30718D',
                strokeWidth: 2
              }} data-id="element-709" data-mp="p1lsf3gektjo" />
                </AreaChart>
              </ResponsiveContainer>
            </div>}

          {selectedChartType === 'Answer Confidence Breakdown' && <div data-id="element-710" data-mp="clvtqcoyoafy">
              <div className="flex items-center justify-between mb-4 sm:mb-5" data-id="element-711" data-mp="7t2prr1bh64x">
                <h3 className="text-sm sm:text-lg font-bold text-gray-900" data-id="element-712" data-mp="7qzogauprqkw">
                  Answer Confidence Breakdown
                  {selectedChartLearnerData ? ` - ${selectedChartLearnerData.name}` : ' - All Learners'}
                  {selectedSkill !== 'All Skills Combined' ? ` - ${selectedSkill}` : ' - All Skills Combined'}
                </h3>
              </div>
              <div className="space-y-3 sm:space-y-4" data-id="element-713" data-mp="2ni1hu2ikv0rx">
                {filteredModuleData.length > 0 ? filteredModuleData.map((module, index) => <div key={index} className="bg-[#F9FAFB] rounded-lg p-3 sm:p-5 border border-[#E5E7EB]" data-id="element-714" data-mp="2x95u2ugvc7j2" data-mpi={index}>
                      <div className="flex items-center justify-between mb-4 sm:mb-6" data-id="element-715" data-mp="329tlhh90eqdt">
                        <div data-id="element-716" data-mp="367hj4s236x9e">
                          <h4 className="font-semibold text-sm sm:text-[14px] text-gray-900" data-id="element-717" data-mp="3b8f0j2f9vn9u">
                            {module.module}
                          </h4>
                        </div>
                        <div className="text-right" data-id="element-718" data-mp="1gue2gjrjr4at">
                          <div className="text-xl sm:text-[25px] font-bold text-[#30718D] leading-none" data-id="element-719" data-mp="1gv5whq5hwtyz">
                            {module.avgScore}%
                          </div>
                          <div className="text-[10px] sm:text-xs font-medium text-gray-500 mt-1" data-id="element-720" data-mp="14jmqjy1dcwyo">
                            Highest Score
                          </div>
                        </div>
                      </div>

                      {/* Answer Confidence Breakdown */}
                      <div data-id="element-721" data-mp="1sa8wnjrtc761">
                        <h5 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-722" data-mp="1s9h5cl590vlk">
                          Answer Confidence Breakdown
                        </h5>

                        {/* Stacked Bar Visualization */}
                        <div className="mb-7" data-id="element-723" data-mp="1idnv58f05e6y">
                          {/* SVG Pattern Definitions */}
                          <svg width="0" height="0" className="absolute" data-id="element-724" data-mp="6wo2gboqsxce">
                            <defs data-id="element-725" data-mp="6xz7eetxcb53">
                              <pattern id={`pattern-diagonal-${module.module}`} patternUnits="userSpaceOnUse" width="8" height="8" data-id="element-726" data-mp="2vau9uy6gi2b">
                                <rect width="8" height="8" fill="#007558" data-id="element-727" data-mp="3qjg8123boce9" />
                                <path d="M-2,2 l4,-4 M0,8 l8,-8 M6,10 l4,-4" stroke="rgba(255,255,255,0.35)" strokeWidth="2.5" data-id="element-728" data-mp="3qliujc59nne8" />
                              </pattern>
                              <pattern id={`pattern-dots-${module.module}`} patternUnits="userSpaceOnUse" width="8" height="8" data-id="element-729" data-mp="3mjxoa9n8m7d0">
                                <rect width="8" height="8" fill="#10B981" data-id="element-730" data-mp="2yt1y1gyfjk7v" />
                                <circle cx="2" cy="2" r="1.5" fill="rgba(255,255,255,0.45)" data-id="element-731" data-mp="32sk9lm4d2iy1" />
                                <circle cx="6" cy="6" r="1.5" fill="rgba(255,255,255,0.45)" data-id="element-732" data-mp="2t5zvnopvjqoq" />
                              </pattern>
                              <pattern id={`pattern-crosshatch-${module.module}`} patternUnits="userSpaceOnUse" width="8" height="8" data-id="element-733" data-mp="2y5kvs2gs6531">
                                <rect width="8" height="8" fill="#DB3725" data-id="element-734" data-mp="3lunjns20cu5z" />
                                <path d="M0,0 l8,8 M8,0 l-8,8" stroke="rgba(255,255,255,0.35)" strokeWidth="2" data-id="element-735" data-mp="3lskjwgb1zmo2" />
                              </pattern>
                              <pattern id={`pattern-horizontal-${module.module}`} patternUnits="userSpaceOnUse" width="8" height="8" data-id="element-736" data-mp="w2ntz0pys1v9">
                                <rect width="8" height="8" fill="#F59E0B" data-id="element-737" data-mp="8gpp3emv2d31" />
                                <line x1="0" y1="2" x2="8" y2="2" stroke="rgba(255,255,255,0.4)" strokeWidth="2" data-id="element-738" data-mp="df0und64i1fg" />
                                <line x1="0" y1="6" x2="8" y2="6" stroke="rgba(255,255,255,0.4)" strokeWidth="2" data-id="element-739" data-mp="3qsvwykp9lqbo" />
                              </pattern>
                            </defs>
                          </svg>
                          {/* Bar */}
                          <div className="h-10 sm:h-12 flex rounded-lg overflow-hidden shadow-sm" data-id="element-740" data-mp="34egefvmd9cp2">
                            <div className="flex items-center justify-center text-white text-xs font-bold transition-all duration-500 hover:opacity-90 overflow-hidden" style={{
                      width: `${module.confidentCorrect}%`,
                      backgroundColor: '#007558',
                      backgroundImage: `url("data:image/svg+xml,%3Csvg width='8' height='8' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='8' height='8' fill='%23007558'/%3E%3Cpath d='M-2,2 l4,-4 M0,8 l8,-8 M6,10 l4,-4' stroke='rgba(255,255,255,0.35)' stroke-width='2.5'/%3E%3C/svg%3E")`
                    }} title={`Confident & Correct: ${module.confidentCorrect}%`} data-id="element-741" data-mp="30cbrffqfbebe">
                              <span className="whitespace-nowrap hidden sm:inline rounded px-1.5 py-0.5 text-white font-bold text-xs" style={{
                        backgroundColor: '#005540'
                      }} data-id="element-742" data-mp="hk2pb8g3jerf">
                                {module.confidentCorrect}%
                              </span>
                            </div>
                            <div className="flex items-center justify-center text-white text-xs font-bold transition-all duration-500 hover:opacity-90 overflow-hidden" style={{
                      width: `${module.uncertainCorrect}%`,
                      backgroundColor: '#10B981'
                    }} title={`Uncertain & Correct: ${module.uncertainCorrect}%`} data-id="element-743" data-mp="3tzwk97xj11fj">
                              <span className="whitespace-nowrap hidden sm:inline rounded px-1.5 py-0.5 text-white font-bold text-xs" style={{
                        backgroundColor: '#0a8a5e'
                      }} data-id="element-744" data-mp="2n7tfd1paz48b">
                                {module.uncertainCorrect}%
                              </span>
                            </div>
                            <div className="flex items-center justify-center text-white text-xs font-bold transition-all duration-500 hover:opacity-90 overflow-hidden" style={{
                      width: `${module.confidentIncorrect}%`,
                      backgroundColor: '#DB3725',
                      backgroundImage: `url("data:image/svg+xml,%3Csvg width='8' height='8' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='8' height='8' fill='%23DB3725'/%3E%3Cpath d='M-2,2 l4,-4 M0,8 l8,-8 M6,10 l4,-4' stroke='rgba(255,255,255,0.35)' stroke-width='2.5'/%3E%3C/svg%3E")`
                    }} title={`Confident & Incorrect: ${module.confidentIncorrect}%`} data-id="element-745" data-mp="35wghbbc6ndho">
                              <span className="whitespace-nowrap hidden sm:inline rounded px-1.5 py-0.5 text-white font-bold text-xs" style={{
                        backgroundColor: '#b02d1e'
                      }} data-id="element-746" data-mp="34h4c1kic8hb8">
                                {module.confidentIncorrect}%
                              </span>
                            </div>
                            <div className="flex items-center justify-center text-white text-xs font-bold transition-all duration-500 hover:opacity-90 overflow-hidden" style={{
                      width: `${module.uncertainIncorrect}%`,
                      backgroundColor: '#F87171'
                    }} title={`Uncertain & Incorrect: ${module.uncertainIncorrect}%`} data-id="element-747" data-mp="159xb334zhzvq">
                              <span className="whitespace-nowrap hidden sm:inline rounded px-1.5 py-0.5 text-white font-bold text-xs" style={{
                        backgroundColor: '#c44a4a'
                      }} data-id="element-748" data-mp="w9infx4js8p2">
                                {module.uncertainIncorrect}%
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* Legend Grid */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 sm:gap-y-5" data-id="element-749" data-mp="269bn7gyb3n5e">
                          {/* Confident & Correct */}
                          <div className="flex items-center gap-3" data-id="element-750" data-mp="2f7xdxzdxm8h9">
                            <span className="text-sm font-bold text-[#007558] flex-shrink-0 w-10 text-right tabular-nums" data-id="element-751" data-mp="2t7yefdqabdw7">
                              {module.confidentCorrect}%
                            </span>
                            <div className="w-6 h-6 rounded flex-shrink-0" style={{
                      backgroundImage: `url("data:image/svg+xml,%3Csvg width='8' height='8' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='8' height='8' fill='%23007558'/%3E%3Cpath d='M-2,2 l4,-4 M0,8 l8,-8 M6,10 l4,-4' stroke='rgba(255,255,255,0.35)' stroke-width='2.5'/%3E%3C/svg%3E")`
                    }} data-id="element-752" data-mp="32xhxajdzz7r2"></div>
                            <div className="flex-1 min-w-0" data-id="element-753" data-mp="3vkj15l2e83dn">
                              <span className="text-xs font-semibold text-gray-800" data-id="element-754" data-mp="3vhwtzmjezpvy">
                                Confident & Correct
                              </span>
                              <p className="text-[11px] text-gray-500 leading-tight" data-id="element-755" data-mp="3mhq93fldznmr">
                                True mastery
                              </p>
                            </div>
                          </div>

                          {/* Uncertain & Correct */}
                          <div className="flex items-center gap-3" data-id="element-756" data-mp="2yv9y855tk69f">
                            <span className="text-sm font-bold text-[#10B981] flex-shrink-0 w-10 text-right tabular-nums" data-id="element-757" data-mp="33sjzci2km6d3">
                              {module.uncertainCorrect}%
                            </span>
                            <div className="w-6 h-6 rounded flex-shrink-0" style={{
                      backgroundColor: '#10B981'
                    }} data-id="element-758" data-mp="2ttudyfbgu3s3"></div>
                            <div className="flex-1 min-w-0" data-id="element-759" data-mp="2107oqpj317f5">
                              <span className="text-xs font-semibold text-gray-800" data-id="element-760" data-mp="210qznmabevjo">
                                Uncertain & Correct
                              </span>
                              <p className="text-[11px] text-gray-500 leading-tight" data-id="element-761" data-mp="2tntti141qi3l">
                                Lucky guesses
                              </p>
                            </div>
                          </div>

                          {/* Confident & Incorrect */}
                          <div className="flex items-center gap-3" data-id="element-762" data-mp="2equcxnr7vewz">
                            <span className="text-sm font-bold text-[#DB3725] flex-shrink-0 w-10 text-right tabular-nums" data-id="element-763" data-mp="18bjzkiv7pxwb">
                              {module.confidentIncorrect}%
                            </span>
                            <div className="w-6 h-6 rounded flex-shrink-0" style={{
                      backgroundImage: `url("data:image/svg+xml,%3Csvg width='8' height='8' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='8' height='8' fill='%23DB3725'/%3E%3Cpath d='M-2,2 l4,-4 M0,8 l8,-8 M6,10 l4,-4' stroke='rgba(255,255,255,0.35)' stroke-width='2.5'/%3E%3C/svg%3E")`
                    }} data-id="element-764" data-mp="3f0kix5615bdx"></div>
                            <div className="flex-1 min-w-0" data-id="element-765" data-mp="6j7q1at5y90d">
                              <span className="text-xs font-semibold text-gray-800" data-id="element-766" data-mp="bjc3eryrynmd">
                                Confident & Incorrect
                              </span>
                              <p className="text-[11px] text-gray-500 leading-tight" data-id="element-767" data-mp="ggca953g7uej">
                                Misinformation
                              </p>
                            </div>
                          </div>

                          {/* Uncertain & Incorrect */}
                          <div className="flex items-center gap-3" data-id="element-768" data-mp="o04uxw73nj8n">
                            <span className="text-sm font-bold text-[#F87171] flex-shrink-0 w-10 text-right tabular-nums" data-id="element-769" data-mp="j1tl3lgt18qf">
                              {module.uncertainIncorrect}%
                            </span>
                            <div className="w-6 h-6 rounded flex-shrink-0" style={{
                      backgroundColor: '#F87171'
                    }} data-id="element-770" data-mp="st6ckbyoxwvx"></div>
                            <div className="flex-1 min-w-0" data-id="element-771" data-mp="f1jbzzxpu27c">
                              <span className="text-xs font-semibold text-gray-800" data-id="element-772" data-mp="eywyljo58sh7">
                                Uncertain & Incorrect
                              </span>
                              <p className="text-[11px] text-gray-500 leading-tight" data-id="element-773" data-mp="1qelks8tkpngy">
                                Needs practice
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>) : <div className="text-center py-8 text-gray-500" data-id="element-774" data-mp="1k0y3q1pvi6pn">
                    No data available for the selected skill.
                  </div>}
              </div>
            </div>}
        </div>
      </div>

      {/* Performance Table Section */}
      <div data-phoebe-tour="analytics-table" className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden mb-6" data-id="element-775" data-mp="2gq5rzhhvmtx9">
        <div className="bg-white px-4 sm:px-6 py-5 border-b border-gray-200" data-id="element-776" data-mp="22xz7jj7oy0s0">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3" data-id="element-777" data-mp="270452t19fhjx">
            <div data-id="element-778" data-mp="2upomv8log8rm">
              <h4 className="text-base font-bold text-gray-900 mb-0.5 flex items-center gap-2" data-id="element-779" data-mp="2up5eojltwyqs">
                <Award size={22} className="text-[#30718D]" data-id="element-780" data-mp="2zhyk79p4gb3x" />
                Performance Table
              </h4>
              <p className="text-sm text-gray-500 ml-[26px]" data-id="element-781" data-mp="2z7teeb8wwys">
                Learner performance by selected metric
              </p>
            </div>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3" data-id="element-782" data-mp="3p78ttkbri4x4">
              {/* Learner search dropdown */}
              <div className="relative" ref={performanceLearnerDropdownRef} data-id="element-783" data-mp="3u73iribz8kfj">
                <button onClick={() => {
                setIsPerformanceLearnerDropdownOpen(!isPerformanceLearnerDropdownOpen);
                setPerformanceLearnerSearch('');
              }} className="flex items-center gap-2 px-3 sm:px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white text-sm font-bold text-gray-900 w-full sm:min-w-[220px]" data-id="element-784" data-mp="lq8pmukzeeen">
                  <UsersRound size={16} className="text-[#30718D]" data-id="element-785" data-mp="19gcs2ymfo842" />
                  <span className="flex-1 text-left truncate" data-id="element-786" data-mp="2u6i79gqhql13">
                    {performanceLearnerFilter}
                  </span>
                  <ChevronDown size={16} className={`transition-transform text-gray-500 ${isPerformanceLearnerDropdownOpen ? 'rotate-180' : ''}`} data-id="element-787" data-mp="2p86wn3sdg6ht" />
                </button>

                {isPerformanceLearnerDropdownOpen && <div className="absolute top-full mt-2 right-0 w-full sm:w-[280px] bg-white border border-gray-200 rounded-lg shadow-lg z-20" data-id="element-788" data-mp="2b749sotjys5u">
                    <div className="p-2 border-b border-gray-100" data-id="element-789" data-mp="26adui3pko0lh">
                      <div className="relative" data-id="element-790" data-mp="2k9dhz81cm9g2">
                        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-791" data-mp="2k5zflzsoq08m" />
                        <input type="text" autoFocus value={performanceLearnerSearch} onChange={e => setPerformanceLearnerSearch(e.target.value)} placeholder="Search learners..." className="w-full pl-8 pr-3 py-2 border border-gray-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#30718D]/40 focus:border-[#30718D]" data-id="element-792" data-mp="3rlw2l2um21fo" />
                      </div>
                    </div>
                    <div className="max-h-64 overflow-y-auto py-1" data-id="element-793" data-mp="2aj22b8ife5rr">
                      {(() => {
                    const uniqueNames = Array.from(new Set(performanceTableData.map(r => r.name))).sort((a, b) => a.localeCompare(b));
                    const options = ['All Learners', ...uniqueNames];
                    const q = performanceLearnerSearch.trim().toLowerCase();
                    const filtered = q ? options.filter(n => n.toLowerCase().includes(q)) : options;
                    if (filtered.length === 0) {
                      return <div className="px-4 py-3 text-sm text-gray-500" data-id="element-794" data-mp="1aavjm1norkm3">
                              No learners found
                            </div>;
                    }
                    return filtered.map(name => <button key={name} onClick={() => {
                      setPerformanceLearnerFilter(name);
                      setIsPerformanceLearnerDropdownOpen(false);
                      setPerformanceLearnerSearch('');
                      setPerformancePage(1);
                    }} className={`w-full px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm ${performanceLearnerFilter === name ? 'bg-[#30718D]/5 text-[#30718D] font-semibold' : 'text-gray-700'}`} data-id="element-795" data-mp="10f22e4z0v2xz">
                            {name}
                          </button>);
                  })()}
                    </div>
                  </div>}
              </div>

              <div className="relative" ref={leaderboardMetricDropdownRef} data-id="element-796" data-mp="27y4dn8ocfo7m">
                <button onClick={() => setIsLeaderboardMetricDropdownOpen(!isLeaderboardMetricDropdownOpen)} className="flex items-center gap-2 px-3 sm:px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white text-sm font-bold text-gray-900 w-full sm:min-w-[200px]" data-id="element-797" data-mp="1tyv6szm126gb">
                  <BarChart3 size={16} className="text-[#30718D]" data-id="element-798" data-mp="3efrhjf468nwy" />
                  <span className="flex-1 text-left" data-id="element-799" data-mp="3jekw7av72kyp">
                    {selectedLeaderboardMetric}
                  </span>
                  <ChevronDown size={16} className={`transition-transform text-gray-500 ${isLeaderboardMetricDropdownOpen ? 'rotate-180' : ''}`} data-id="element-800" data-mp="17rr1zi84ppah" />
                </button>

                {isLeaderboardMetricDropdownOpen && <div className="absolute top-full mt-2 right-0 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-10" data-id="element-801" data-mp="1cp10dndhxbag">
                    {['Average Score', 'Total Assessments', 'Completion Rate', 'Mastery Level'].map(metric => <button key={metric} onClick={() => {
                  setSelectedLeaderboardMetric(metric);
                  setIsLeaderboardMetricDropdownOpen(false);
                }} className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0 text-sm ${selectedLeaderboardMetric === metric ? 'bg-[#30718D]/5 text-[#30718D] font-semibold' : 'text-gray-700'}`} data-id="element-802" data-mp="1vgk2lrzp4lbf">
                        {metric}
                      </button>)}
                  </div>}
              </div>

              <div className="relative" ref={leaderboardSkillDropdownRef} data-id="element-803" data-mp="14o3754ww3eez">
                <button onClick={() => setIsLeaderboardSkillDropdownOpen(!isLeaderboardSkillDropdownOpen)} className="flex items-center gap-2 px-3 sm:px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white text-sm font-bold text-gray-900 w-full sm:min-w-[200px]" data-id="element-804" data-mp="19pae51r7k9kl">
                  <Target size={16} className="text-[#30718D]" data-id="element-805" data-mp="1xev8shwq4v9p" />
                  <span className="flex-1 text-left" data-id="element-806" data-mp="1xfd0r2ccsnbt">
                    {selectedLeaderboardSkill}
                  </span>
                  <ChevronDown size={16} className={`transition-transform text-gray-500 ${isLeaderboardSkillDropdownOpen ? 'rotate-180' : ''}`} data-id="element-807" data-mp="3cy2lqmqi691u" />
                </button>

                {isLeaderboardSkillDropdownOpen && <div className="absolute top-full mt-2 right-0 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-10" data-id="element-808" data-mp="331zgv949nwb7">
                    {skillOptions.map(skill => <button key={skill} onClick={() => {
                  setSelectedLeaderboardSkill(skill);
                  setIsLeaderboardSkillDropdownOpen(false);
                }} className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0 text-sm ${selectedLeaderboardSkill === skill ? 'bg-[#30718D]/5 text-[#30718D] font-semibold' : 'text-gray-700'}`} data-id="element-809" data-mp="3vpc4lmm5ya63">
                        {skill}
                      </button>)}
                  </div>}
              </div>
            </div>
          </div>
        </div>

        {/* Performance Table List */}
        {(() => {
        const parsePct = (v: string | number) => {
          if (typeof v === 'number') return v;
          const cleaned = String(v).replace('%', '').replace('+', '').trim();
          const n = parseFloat(cleaned);
          return isNaN(n) ? 0 : n;
        };
        const learnerFilteredPerf = performanceLearnerFilter === 'All Learners' ? performanceTableData : performanceTableData.filter(r => r.name === performanceLearnerFilter);
        const sortedPerf = [...learnerFilteredPerf].sort((a, b) => {
          const key = performanceSortKey;
          const valA = a[key];
          const valB = b[key];
          if (key === 'name') {
            const strA = String(valA).toLowerCase();
            const strB = String(valB).toLowerCase();
            return performanceSortDir === 'asc' ? strA.localeCompare(strB) : strB.localeCompare(strA);
          }
          const numA = parsePct(valA as any);
          const numB = parsePct(valB as any);
          return performanceSortDir === 'asc' ? numA - numB : numB - numA;
        });
        const totalPages = Math.max(1, Math.ceil(sortedPerf.length / performancePerPage));
        const safePage = Math.min(performancePage, totalPages);
        const paginated = sortedPerf.slice((safePage - 1) * performancePerPage, safePage * performancePerPage);
        const isActive = (key: PerformanceTableSortKey) => performanceSortKey === key;
        const SortArrow = ({
          columnKey
        }: {
          columnKey: PerformanceTableSortKey;
        }) => {
          if (!isActive(columnKey)) {
            return <ChevronsUpDown size={14} className="text-gray-400" data-id="element-810" data-mp="4kfzvph891co" />;
          }
          return performanceSortDir === 'asc' ? <ChevronUp size={14} className="text-[#30718D]" data-id="element-811" data-mp="3rqgnjnw489f4" /> : <ChevronDown size={14} className="text-[#30718D]" data-id="element-812" data-mp="3ronhoatbtt86" />;
        };
        const headerBtnClass = (columnKey: PerformanceTableSortKey) => `flex items-center gap-1 text-left text-sm font-medium transition-colors ${isActive(columnKey) ? 'text-[#30718D]' : 'text-gray-700 hover:text-gray-900'}`;
        const cellActiveClass = (columnKey: PerformanceTableSortKey) => isActive(columnKey) ? 'bg-[#30718D]/5' : '';
        const headerActiveClass = (columnKey: PerformanceTableSortKey) => isActive(columnKey) ? 'bg-[#30718D]/10' : '';
        return <div className="overflow-x-auto" data-id="element-813" data-mp="1ejqwdspwp1bl">
              <table className="w-full text-sm" data-id="element-814" data-mp="1el1y7mzsjz02">
                <thead data-id="element-815" data-mp="1jiv40ex6mqzt">
                  <tr className="border-b border-gray-200 bg-gray-50" data-id="element-816" data-mp="1jibthj9v34vt">
                    <th className="text-left px-4 sm:px-6 py-3 whitespace-nowrap w-12" data-id="element-817" data-mp="1nkgoalc1q7k1">
                      <span className="text-sm font-medium text-gray-700" data-id="element-818" data-mp="1nim110day3cs">
                        #
                      </span>
                    </th>
                    <th className={`text-left px-4 sm:px-6 py-3 whitespace-nowrap transition-colors ${headerActiveClass('name')}`} data-id="element-819" data-mp="1x96z8mp2d5v6">
                      <button onClick={() => handlePerformanceSort('name')} className={headerBtnClass('name')} data-id="element-820" data-mp="277whwhosauch">
                        Learner Name
                        <SortArrow columnKey="name" data-id="element-821" data-mp="cvgctk7q5m97" />
                      </button>
                    </th>
                    <th className={`text-left px-4 sm:px-6 py-3 whitespace-nowrap transition-colors ${headerActiveClass('finalScore')}`} data-id="element-822" data-mp="gwrw78009b8y">
                      <button onClick={() => handlePerformanceSort('finalScore')} className={headerBtnClass('finalScore')} data-id="element-823" data-mp="1f8mewm70yzdm">
                        Final Score
                        <SortArrow columnKey="finalScore" data-id="element-824" data-mp="1p4pdji2o4fvt" />
                      </button>
                    </th>
                    <th className={`text-left px-4 sm:px-6 py-3 whitespace-nowrap transition-colors ${headerActiveClass('improvement')}`} data-id="element-825" data-mp="233p08k6mekpc">
                      <button onClick={() => handlePerformanceSort('improvement')} className={headerBtnClass('improvement')} data-id="element-826" data-mp="2cv1qx8gon4ts">
                        Improvement Rate
                        <SortArrow columnKey="improvement" data-id="element-827" data-mp="2gx6j02rhfteb" />
                      </button>
                    </th>
                    <th className={`text-left px-4 sm:px-6 py-3 whitespace-nowrap transition-colors ${headerActiveClass('attempts')}`} data-id="element-828" data-mp="30igmmf43xaef">
                      <button onClick={() => handlePerformanceSort('attempts')} className={headerBtnClass('attempts')} data-id="element-829" data-mp="2riaaawk5aggu">
                        Attempts
                        <SortArrow columnKey="attempts" data-id="element-830" data-mp="2hs77k4n81o5b" />
                      </button>
                    </th>
                    <th className={`text-left px-4 sm:px-6 py-3 max-w-[180px] transition-colors ${headerActiveClass('confidentCorrect')}`} data-id="element-831" data-mp="2mk8quait4f4u">
                      <button onClick={() => handlePerformanceSort('confidentCorrect')} className={`${headerBtnClass('confidentCorrect')} items-start text-left`} data-id="element-832" data-mp="2csm8zvbyrht4">
                        <span className="leading-snug" data-id="element-833" data-mp="1vrqgeeat0g4x">
                          Confident & Correct Rate
                        </span>
                        <SortArrow columnKey="confidentCorrect" data-id="element-834" data-mp="1qu84cf1hpksp" />
                      </button>
                    </th>
                    <th className={`text-left px-4 sm:px-6 py-3 max-w-[180px] transition-colors ${headerActiveClass('confidentIncorrect')}`} data-id="element-835" data-mp="1m0dr9uge442l">
                      <button onClick={() => handlePerformanceSort('confidentIncorrect')} className={`${headerBtnClass('confidentIncorrect')} items-start text-left`} data-id="element-836" data-mp="1d33bpwwjhsrv">
                        <span className="leading-snug" data-id="element-837" data-mp="z32auhg9ylce">
                          Confident & Incorrect Rate
                        </span>
                        <SortArrow columnKey="confidentIncorrect" data-id="element-838" data-mp="2xf0za69ibwge" />
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-839" data-mp="f7hhytwojtge">
                  {paginated.map((row, idx) => {
                const rank = (safePage - 1) * performancePerPage + idx + 1;
                return <tr key={`${row.name}-${idx}`} className="border-b border-gray-100 last:border-b-0 hover:bg-gray-50 transition-colors" data-id="element-840" data-mp="oz3qgihmvefg" data-mpi={idx}>
                        <td className="px-4 sm:px-6 py-4 text-gray-400 tabular-nums align-middle" data-id="element-841" data-mp="3sg3th4wogywc">
                          {rank}
                        </td>
                        <td className={`px-4 sm:px-6 py-4 font-medium text-gray-900 align-middle whitespace-nowrap transition-colors ${cellActiveClass('name')}`} data-id="element-842" data-mp="59bfob6yolb0">
                          {row.name}
                        </td>
                        <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle tabular-nums whitespace-nowrap transition-colors ${cellActiveClass('finalScore')}`} data-id="element-843" data-mp="1lo3309p932dg">
                          {row.finalScore}
                        </td>
                        <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle tabular-nums whitespace-nowrap transition-colors ${cellActiveClass('improvement')}`} data-id="element-844" data-mp="3rpdq3p7kpsjw">
                          {row.improvement}
                        </td>
                        <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle tabular-nums whitespace-nowrap transition-colors ${cellActiveClass('attempts')}`} data-id="element-845" data-mp="2yydotm0mn2vx">
                          {row.attempts}
                        </td>
                        <td className={`px-4 sm:px-6 py-4 align-middle tabular-nums whitespace-nowrap transition-colors ${cellActiveClass('confidentCorrect')}`} data-id="element-846" data-mp="33xqai3fri3wx">
                          <span className="text-[#30718D] font-medium" data-id="element-847" data-mp="qt3d93dtt93e">
                            {row.confidentCorrect}
                          </span>
                        </td>
                        <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle tabular-nums whitespace-nowrap transition-colors ${cellActiveClass('confidentIncorrect')}`} data-id="element-848" data-mp="vlwcxcuftr8m">
                          {row.confidentIncorrect}
                        </td>
                      </tr>;
              })}
                </tbody>
              </table>

              {/* Pagination */}
              {sortedPerf.length > 0 && <div className="flex items-center justify-between px-4 sm:px-6 py-3 border-t border-gray-200" data-id="element-849" data-mp="10l0o290x9z1l">
                  <p className="text-sm text-gray-600" data-id="element-850" data-mp="3l9576t3krvuu">
                    Showing {(safePage - 1) * performancePerPage + 1}–
                    {Math.min(safePage * performancePerPage, sortedPerf.length)}{' '}
                    of {sortedPerf.length}
                  </p>
                  <div className="flex items-center gap-2" data-id="element-851" data-mp="ku8nr0drkk15">
                    <span className="text-sm text-gray-600" data-id="element-852" data-mp="gq9d2yf60ffp">Page</span>
                    <div className="relative" ref={performancePageDropdownRef} data-id="element-853" data-mp="brzgcjdsl6rz">
                      <button type="button" onClick={() => setIsPerformancePageDropdownOpen(open => !open)} aria-haspopup="listbox" aria-expanded={isPerformancePageDropdownOpen} aria-label="Select page" className={`flex min-w-14 items-center justify-between rounded-md border bg-white py-1 pl-2 pr-2 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-[#30718D]/20 ${isPerformancePageDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]/20 text-[#30718D]' : 'border-gray-300 text-gray-700'}`} data-id="element-854" data-mp="bu2fpu0u4c9d">
                        <span data-id="element-855" data-mp="1psvwcqtigja2">{safePage}</span>
                        <ChevronDown size={14} aria-hidden="true" className={`ml-2 text-gray-400 transition-transform ${isPerformancePageDropdownOpen ? 'rotate-180' : ''}`} data-id="element-856" data-mp="1pu6yynb7zkzl" />
                      </button>
                      {isPerformancePageDropdownOpen && <div role="listbox" aria-label="Select page" className="absolute bottom-full z-30 mb-1 max-h-60 min-w-full overflow-y-auto overflow-x-hidden rounded-lg border border-gray-200 bg-white shadow-lg" data-id="element-857" data-mp="28pwze63i89bd">
                          {Array.from({
                    length: totalPages
                  }, (_, i) => i + 1).map(page => <button key={page} type="button" role="option" aria-selected={safePage === page} onClick={() => {
                    setPerformancePage(page);
                    setIsPerformancePageDropdownOpen(false);
                  }} className={`flex w-full items-center border-b border-gray-100 px-3 py-2 text-left text-sm transition-colors last:border-b-0 ${safePage === page ? 'bg-[#30718D]/10 font-medium text-[#30718D]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-858" data-mp="3vwwgl5dfjubq">
                              {page}
                            </button>)}
                        </div>}
                    </div>
                    <span className="text-sm text-gray-600" data-id="element-859" data-mp="16enro5d8zviz">
                      of {totalPages}
                    </span>
                  </div>
                </div>}
            </div>;
      })()}
      </div>
      {/* End Performance Table Section */}
    </>;
}
function IndividualView({
  learner,
  modulePerformance,
  actionItems,
  COLORS,
  selectedSkill,
  setSelectedSkill,
  isSkillDropdownOpen,
  setIsSkillDropdownOpen,
  skillDropdownRef,
  skillOptions,
  selectedLearner,
  setSelectedLearner,
  selectedLearnerData,
  isLearnerDropdownOpen,
  setIsLearnerDropdownOpen,
  learnerDropdownRef
}) {
  // Filter action items for this specific learner (only non-macro items have learner property)
  const learnerActions = actionItems.filter(item => item.learner && (item.learner.name === learner.name || item.learner.email === learner.email));
  // Filter module performance based on selected skill
  const filteredModulePerformance = selectedSkill === 'All Skills Combined' ? modulePerformance : modulePerformance.filter(m => m.module === selectedSkill);
  // Modal states
  const [messageModal, setMessageModal] = useState<{
    isOpen: boolean;
    item: any | null;
  }>({
    isOpen: false,
    item: null
  });
  const [meetingModal, setMeetingModal] = useState<{
    isOpen: boolean;
    item: any | null;
  }>({
    isOpen: false,
    item: null
  });
  const [kudosModal, setKudosModal] = useState<{
    isOpen: boolean;
    item: any | null;
  }>({
    isOpen: false,
    item: null
  });
  // Get recipient name for modals
  const getRecipientName = (item: any) => {
    if (item.learner) return item.learner.name;
    return 'Team';
  };
  const getRecipientFirstName = (item: any) => {
    if (item.learner) return item.learner.name.split(' ')[0];
    return 'Team';
  };
  // Learner-specific skill data for badges, certificates, assessments, scores, and dates
  const learnerSkillData = {
    // Linda Taylor (id: 1)
    1: {
      'HTML Basics': {
        badgeEarned: true,
        certificateAchieved: true,
        assessments: 2,
        avgScore: 92,
        lastAttempt: '2024-01-12'
      },
      'CSS Fundamentals': {
        badgeEarned: true,
        certificateAchieved: false,
        assessments: 1,
        avgScore: 85,
        lastAttempt: '2024-01-10'
      },
      'JavaScript Basics': {
        badgeEarned: false,
        certificateAchieved: false,
        assessments: 3,
        avgScore: 78,
        lastAttempt: '2024-01-15'
      },
      'Responsive Design': {
        badgeEarned: true,
        certificateAchieved: false,
        assessments: 1,
        avgScore: 88,
        lastAttempt: '2024-01-08'
      }
    },
    // John Smith (id: 2)
    2: {
      'HTML Basics': {
        badgeEarned: true,
        certificateAchieved: false,
        assessments: 2,
        avgScore: 75,
        lastAttempt: '2024-01-11'
      },
      'CSS Fundamentals': {
        badgeEarned: false,
        certificateAchieved: false,
        assessments: 2,
        avgScore: 62,
        lastAttempt: '2024-01-13'
      },
      'JavaScript Basics': {
        badgeEarned: false,
        certificateAchieved: false,
        assessments: 3,
        avgScore: 58,
        lastAttempt: '2024-01-14'
      },
      'Responsive Design': {
        badgeEarned: false,
        certificateAchieved: false,
        assessments: 1,
        avgScore: 70,
        lastAttempt: '2024-01-09'
      }
    },
    // Sarah Johnson (id: 3)
    3: {
      'HTML Basics': {
        badgeEarned: true,
        certificateAchieved: true,
        assessments: 1,
        avgScore: 96,
        lastAttempt: '2024-01-10'
      },
      'CSS Fundamentals': {
        badgeEarned: true,
        certificateAchieved: true,
        assessments: 1,
        avgScore: 94,
        lastAttempt: '2024-01-12'
      },
      'JavaScript Basics': {
        badgeEarned: true,
        certificateAchieved: true,
        assessments: 1,
        avgScore: 95,
        lastAttempt: '2024-01-14'
      },
      'Responsive Design': {
        badgeEarned: true,
        certificateAchieved: true,
        assessments: 1,
        avgScore: 97,
        lastAttempt: '2024-01-16'
      }
    },
    // Michael Chen (id: 4)
    4: {
      'HTML Basics': {
        badgeEarned: true,
        certificateAchieved: false,
        assessments: 2,
        avgScore: 82,
        lastAttempt: '2024-01-08'
      },
      'CSS Fundamentals': {
        badgeEarned: false,
        certificateAchieved: false,
        assessments: 3,
        avgScore: 65,
        lastAttempt: '2024-01-13'
      },
      'JavaScript Basics': {
        badgeEarned: true,
        certificateAchieved: false,
        assessments: 2,
        avgScore: 80,
        lastAttempt: '2024-01-11'
      },
      'Responsive Design': {
        badgeEarned: false,
        certificateAchieved: false,
        assessments: 1,
        avgScore: 72,
        lastAttempt: '2024-01-06'
      }
    },
    // Emily Davis (id: 5)
    5: {
      'HTML Basics': {
        badgeEarned: true,
        certificateAchieved: true,
        assessments: 2,
        avgScore: 88,
        lastAttempt: '2024-01-15'
      },
      'CSS Fundamentals': {
        badgeEarned: true,
        certificateAchieved: false,
        assessments: 1,
        avgScore: 90,
        lastAttempt: '2024-01-12'
      },
      'JavaScript Basics': {
        badgeEarned: true,
        certificateAchieved: false,
        assessments: 2,
        avgScore: 85,
        lastAttempt: '2024-01-14'
      },
      'Responsive Design': {
        badgeEarned: true,
        certificateAchieved: false,
        assessments: 1,
        avgScore: 91,
        lastAttempt: '2024-01-10'
      }
    }
  };
  // Get skill-specific data for current learner
  const currentLearnerSkillData = learnerSkillData[learner.id] || learnerSkillData[1];
  const currentSkillData = selectedSkill !== 'All Skills Combined' ? currentLearnerSkillData[selectedSkill] : null;
  // Learner-specific progress data for charts - different data for each learner
  const learnerProgressData = {
    // Linda Taylor (id: 1) - Strong performer with steady improvement
    1: {
      'All Skills Combined': {
        score: [{
          attempt: 'Attempt 1',
          score: 72
        }, {
          attempt: 'Attempt 2',
          score: 85
        }, {
          attempt: 'Attempt 3',
          score: 92
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 68
        }, {
          attempt: 'Attempt 2',
          mastery: 78
        }, {
          attempt: 'Attempt 3',
          mastery: 88
        }]
      },
      'HTML Basics': {
        score: [{
          attempt: 'Attempt 1',
          score: 85
        }, {
          attempt: 'Attempt 2',
          score: 92
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 88
        }, {
          attempt: 'Attempt 2',
          mastery: 95
        }]
      },
      'CSS Fundamentals': {
        score: [{
          attempt: 'Attempt 1',
          score: 85
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 88
        }]
      },
      'JavaScript Basics': {
        score: [{
          attempt: 'Attempt 1',
          score: 62
        }, {
          attempt: 'Attempt 2',
          score: 70
        }, {
          attempt: 'Attempt 3',
          score: 78
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 55
        }, {
          attempt: 'Attempt 2',
          mastery: 65
        }, {
          attempt: 'Attempt 3',
          mastery: 75
        }]
      },
      'Responsive Design': {
        score: [{
          attempt: 'Attempt 1',
          score: 88
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 90
        }]
      }
    },
    // John Smith (id: 2) - Struggling learner with declining scores in some areas
    2: {
      'All Skills Combined': {
        score: [{
          attempt: 'Attempt 1',
          score: 65
        }, {
          attempt: 'Attempt 2',
          score: 68
        }, {
          attempt: 'Attempt 3',
          score: 72
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 55
        }, {
          attempt: 'Attempt 2',
          mastery: 60
        }, {
          attempt: 'Attempt 3',
          mastery: 65
        }]
      },
      'HTML Basics': {
        score: [{
          attempt: 'Attempt 1',
          score: 68
        }, {
          attempt: 'Attempt 2',
          score: 75
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 62
        }, {
          attempt: 'Attempt 2',
          mastery: 72
        }]
      },
      'CSS Fundamentals': {
        score: [{
          attempt: 'Attempt 1',
          score: 55
        }, {
          attempt: 'Attempt 2',
          score: 62
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 48
        }, {
          attempt: 'Attempt 2',
          mastery: 58
        }]
      },
      'JavaScript Basics': {
        score: [{
          attempt: 'Attempt 1',
          score: 68
        }, {
          attempt: 'Attempt 2',
          score: 65
        }, {
          attempt: 'Attempt 3',
          score: 58
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 60
        }, {
          attempt: 'Attempt 2',
          mastery: 55
        }, {
          attempt: 'Attempt 3',
          mastery: 50
        }]
      },
      'Responsive Design': {
        score: [{
          attempt: 'Attempt 1',
          score: 70
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 65
        }]
      }
    },
    // Sarah Johnson (id: 3) - High performer, first-attempt success
    3: {
      'All Skills Combined': {
        score: [{
          attempt: 'Attempt 1',
          score: 95
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 94
        }]
      },
      'HTML Basics': {
        score: [{
          attempt: 'Attempt 1',
          score: 96
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 95
        }]
      },
      'CSS Fundamentals': {
        score: [{
          attempt: 'Attempt 1',
          score: 94
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 92
        }]
      },
      'JavaScript Basics': {
        score: [{
          attempt: 'Attempt 1',
          score: 95
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 93
        }]
      },
      'Responsive Design': {
        score: [{
          attempt: 'Attempt 1',
          score: 97
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 96
        }]
      }
    },
    // Michael Chen (id: 4) - Mixed performance, struggles with CSS
    4: {
      'All Skills Combined': {
        score: [{
          attempt: 'Attempt 1',
          score: 70
        }, {
          attempt: 'Attempt 2',
          score: 75
        }, {
          attempt: 'Attempt 3',
          score: 78
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 62
        }, {
          attempt: 'Attempt 2',
          mastery: 68
        }, {
          attempt: 'Attempt 3',
          mastery: 72
        }]
      },
      'HTML Basics': {
        score: [{
          attempt: 'Attempt 1',
          score: 75
        }, {
          attempt: 'Attempt 2',
          score: 82
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 70
        }, {
          attempt: 'Attempt 2',
          mastery: 80
        }]
      },
      'CSS Fundamentals': {
        score: [{
          attempt: 'Attempt 1',
          score: 52
        }, {
          attempt: 'Attempt 2',
          score: 58
        }, {
          attempt: 'Attempt 3',
          score: 65
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 45
        }, {
          attempt: 'Attempt 2',
          mastery: 52
        }, {
          attempt: 'Attempt 3',
          mastery: 60
        }]
      },
      'JavaScript Basics': {
        score: [{
          attempt: 'Attempt 1',
          score: 72
        }, {
          attempt: 'Attempt 2',
          score: 80
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 68
        }, {
          attempt: 'Attempt 2',
          mastery: 78
        }]
      },
      'Responsive Design': {
        score: [{
          attempt: 'Attempt 1',
          score: 72
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 68
        }]
      }
    },
    // Emily Davis (id: 5) - Good performer with significant improvement
    5: {
      'All Skills Combined': {
        score: [{
          attempt: 'Attempt 1',
          score: 65
        }, {
          attempt: 'Attempt 2',
          score: 88
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 60
        }, {
          attempt: 'Attempt 2',
          mastery: 85
        }]
      },
      'HTML Basics': {
        score: [{
          attempt: 'Attempt 1',
          score: 65
        }, {
          attempt: 'Attempt 2',
          score: 88
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 60
        }, {
          attempt: 'Attempt 2',
          mastery: 92
        }]
      },
      'CSS Fundamentals': {
        score: [{
          attempt: 'Attempt 1',
          score: 90
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 88
        }]
      },
      'JavaScript Basics': {
        score: [{
          attempt: 'Attempt 1',
          score: 78
        }, {
          attempt: 'Attempt 2',
          score: 85
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 72
        }, {
          attempt: 'Attempt 2',
          mastery: 82
        }]
      },
      'Responsive Design': {
        score: [{
          attempt: 'Attempt 1',
          score: 91
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 89
        }]
      }
    }
  };
  // Get the appropriate data for the selected learner and skill
  const currentLearnerProgressData = learnerProgressData[learner.id] || learnerProgressData[1];
  const currentSkillProgressData = currentLearnerProgressData[selectedSkill] || currentLearnerProgressData['All Skills Combined'];
  const scoreProgressData = currentSkillProgressData.score;
  const masteryProgressData = currentSkillProgressData.mastery;
  return <>
      {/* Learner Header */}
      <div className="bg-white rounded-xl p-4 sm:p-6 shadow-sm border border-gray-100 mb-6" data-id="element-860" data-mp="1x7cxnxp5za0e">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-861" data-mp="226fs6o7ipxu4">
          <div className="flex items-center gap-4" data-id="element-862" data-mp="3gfae0hc36mml">
            <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-[#30718D] flex items-center justify-center text-white text-lg sm:text-xl font-bold shadow-sm" data-id="element-863" data-mp="3cdx3vv1ynx9v">
              {learner.name.split(' ').map(n => n[0]).join('')}
            </div>
            <div data-id="element-864" data-mp="37yxphrgxgm5">
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900" data-id="element-865" data-mp="37felxq30m6j">
                {learner.name}
              </h2>
              <p className="text-gray-600 text-sm" data-id="element-866" data-mp="3vc141zzvelzj">{learner.email}</p>
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2 sm:gap-3" data-id="element-867" data-mp="cxicab85eob7">
            {/* Badge - Conditional based on skill selection */}
            <div className="text-center px-3 sm:px-6 py-2 sm:py-3 bg-gray-50 rounded-lg border border-gray-100" data-id="element-868" data-mp="mvogizhfg6j8">
              <div className="text-xs font-medium text-gray-500 mb-1" data-id="element-869" data-mp="hyfycywa42hz">
                {currentSkillData ? 'Badge Earned' : 'Badges Earned'}
              </div>
              {currentSkillData ? <div className={`text-base sm:text-lg font-bold ${currentSkillData.badgeEarned ? 'text-[#007558]' : 'text-gray-400'}`} data-id="element-870" data-mp="15jqg0us3bsom">
                  {currentSkillData.badgeEarned ? 'Yes' : 'No'}
                </div> : <div className="text-xl sm:text-2xl font-bold text-gray-900" data-id="element-871" data-mp="hunrr42yb1l5">
                  12
                </div>}
            </div>

            {/* Certificate - Conditional based on skill selection */}
            <div className="text-center px-3 sm:px-6 py-2 sm:py-3 bg-gray-50 rounded-lg border border-gray-100" data-id="element-872" data-mp="8vskrps31ngs">
              <div className="text-xs font-medium text-gray-500 mb-1" data-id="element-873" data-mp="du3ywcpeuk4t">
                {currentSkillData ? 'Certificate Achieved' : 'Certificates Achieved'}
              </div>
              {currentSkillData ? <div className={`text-base sm:text-lg font-bold ${currentSkillData.certificateAchieved ? 'text-[#007558]' : 'text-gray-400'}`} data-id="element-874" data-mp="30rvnej2j3p20">
                  {currentSkillData.certificateAchieved ? 'Yes' : 'No'}
                </div> : <div className="text-xl sm:text-2xl font-bold text-gray-900" data-id="element-875" data-mp="2vt29wqn8ry1u">
                  3
                </div>}
            </div>

            {/* Total Assessments - Updates based on skill */}
            <div className="text-center px-3 sm:px-6 py-2 sm:py-3 bg-gray-50 rounded-lg border border-gray-100" data-id="element-876" data-mp="2msvz5cixhc6d">
              <div className="text-xs font-medium text-gray-500 mb-1" data-id="element-877" data-mp="284sqtwhexoee">
                Total Assessments
              </div>
              <div className="text-xl sm:text-2xl font-bold text-gray-900" data-id="element-878" data-mp="2d3428bncw6yq">
                {currentSkillData ? currentSkillData.assessments : learner.assessments}
              </div>
            </div>

            {/* Average Score - Updates based on skill */}
            <div className="text-center px-3 sm:px-6 py-2 sm:py-3 bg-gray-50 rounded-lg border border-gray-100" data-id="element-879" data-mp="1kgmh2swfq3r8">
              <div className="text-xs font-medium text-gray-500 mb-1" data-id="element-880" data-mp="1fjcl0uejituf">
                Average Score
              </div>
              <div className="text-xl sm:text-2xl font-bold text-[#30718D]" data-id="element-881" data-mp="1ohxywc92hkov">
                {currentSkillData ? currentSkillData.avgScore : learner.avgScore}
                %
              </div>
            </div>

            {/* Last Attempt / Attempted Date - Updates based on skill */}
            <div className="text-center px-3 sm:px-6 py-2 sm:py-3 bg-gray-50 rounded-lg border border-gray-100 col-span-2 sm:col-span-1" data-id="element-882" data-mp="2c7sayrlkb582">
              <div className="text-xs font-medium text-gray-500 mb-1" data-id="element-883" data-mp="286qiquq2btfl">
                {currentSkillData ? 'Attempted Date' : 'Last Attempt'}
              </div>
              <div className="text-base sm:text-lg font-semibold text-gray-900" data-id="element-884" data-mp="2h7eol25aynhe">
                {currentSkillData ? currentSkillData.lastAttempt : learner.lastAttempt}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Individual Learner Progress Section */}
      <div className="bg-white rounded-xl p-4 sm:p-6 shadow-sm border border-gray-100 mb-6" data-id="element-885" data-mp="1nskn8v0l1oj5">
        <div className="flex items-start justify-between mb-6" data-id="element-886" data-mp="1sm6o7pxdw3z4">
          <div data-id="element-887" data-mp="1xkhzm53bumjg">
            <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-888" data-mp="1xinh0xfj36ij">
              Individual Learner Progress
            </h3>
            <p className="text-sm text-gray-600" data-id="element-889" data-mp="22gypb3q6d8yn">
              Track attempt-by-attempt progress for {learner.name.split(' ')[0]}{' '}
              in {selectedSkill}
            </p>
          </div>
          {selectedSkill !== 'All Skills Combined' && <span className="px-3 py-1 bg-[#30718D]/10 text-[#30718D] rounded-full text-sm font-medium" data-id="element-890" data-mp="c75ioq0akk1j">
              Viewing: {selectedSkill}
            </span>}
        </div>

        {/* Progress Charts */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-891" data-mp="9mpl8krfc4aj">
          {/* Score Progress Chart */}
          <div className="bg-gray-50 rounded-lg p-6 border border-gray-200" data-id="element-892" data-mp="4tmq48700ms8">
            <h4 className="text-base font-bold text-gray-900 text-center mb-6" data-id="element-893" data-mp="3w0qsgps77kub">
              Score Progress
            </h4>
            <ResponsiveContainer width="100%" height={400} data-id="element-894" data-mp="3r40h2frc9df8">
              <LineChart data={scoreProgressData} margin={{
              bottom: 20
            }} data-id="element-895" data-mp="slbl5wb7fpcv">
                <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" data-id="element-896" data-mp="njm8ydc8x5n7" />
                <XAxis dataKey="attempt" label={{
                value: 'Attempts',
                position: 'insideBottom',
                offset: -10
              }} tick={{
                fontSize: 12
              }} data-id="element-897" data-mp="il19ig4tipzt" />
                <YAxis domain={[0, 100]} label={{
                value: 'Percentage (%)',
                angle: -90,
                position: 'insideLeft'
              }} tick={{
                fontSize: 12
              }} data-id="element-898" data-mp="2zdcinbh1um59" />
                <Tooltip data-id="element-899" data-mp="m3768ntuzslj" />
                <Line type="monotone" dataKey="score" stroke="#30718D" strokeWidth={3} dot={{
                fill: '#30718D',
                r: 6
              }} activeDot={{
                r: 8
              }} data-id="element-900" data-mp="m4i9mmje6yc4" />
              </LineChart>
            </ResponsiveContainer>
          </div>

          {/* Mastery Rate Progress Chart */}
          <div className="bg-gray-50 rounded-lg p-6 border border-gray-200" data-id="element-901" data-mp="3li2gedqa4kgu">
            <h4 className="text-base font-bold text-gray-900 text-center mb-6" data-id="element-902" data-mp="3pk79nbctff2y">
              Mastery Rate Progress
            </h4>
            <ResponsiveContainer width="100%" height={400} data-id="element-903" data-mp="3hzv691bowxtr">
              <LineChart data={masteryProgressData} margin={{
              bottom: 20
            }} data-id="element-904" data-mp="3d1ldexdfu9bb">
                <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" data-id="element-905" data-mp="3ryc3gg1828o9" />
                <XAxis dataKey="attempt" label={{
                value: 'Attempts',
                position: 'insideBottom',
                offset: -10
              }} tick={{
                fontSize: 12
              }} data-id="element-906" data-mp="3mzhndlun2y7u" />
                <YAxis domain={[0, 100]} label={{
                value: 'Percentage (%)',
                angle: -90,
                position: 'insideLeft'
              }} tick={{
                fontSize: 12
              }} data-id="element-907" data-mp="391j9ehk8d3sv" />
                <Tooltip data-id="element-908" data-mp="2bihscigwq5a4" />
                <Line type="monotone" dataKey="mastery" stroke="#007558" strokeWidth={3} dot={{
                fill: '#007558',
                r: 6
              }} activeDot={{
                r: 8
              }} data-id="element-909" data-mp="318znvnl8tlyb" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Recommended Actions Section */}
      <AnimatePresence mode="wait" data-id="element-910" data-mp="2maxjjb6e0wg0">
        {learnerActions.length > 0 && <motion.div key={learner.id} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.3
      }} className="mb-6" data-id="element-911" data-mp="2rajxjmu1igpv"></motion.div>}
      </AnimatePresence>

      {/* Individual Module Performance */}
      <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 mb-6" data-id="element-912" data-mp="1r2dgekey83mb">
        <div className="flex items-center justify-between mb-5" data-id="element-913" data-mp="1r4pyqyomcfzw">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-914" data-mp="1ma2i1lzuwpvv">
            {selectedSkill === 'All Skills Combined' ? 'Module Performance' : `${selectedSkill} Performance`}
          </h3>
          {selectedSkill !== 'All Skills Combined' && <span className="px-3 py-1 bg-[#30718D]/10 text-[#30718D] rounded-full text-sm font-medium" data-id="element-915" data-mp="18bmc3x9tj3es">
              Filtered
            </span>}
        </div>
        <div className="space-y-4" data-id="element-916" data-mp="ydptkkejx66n">
          {filteredModulePerformance.length > 0 ? filteredModulePerformance.map((module, index) => <div key={index} className="bg-gray-50 rounded-lg p-5 border border-gray-200" data-id="element-917" data-mp="2xqadl3gvf0y1" data-mpi={index}>
                <div className="flex items-center justify-between mb-4" data-id="element-918" data-mp="21md7v1ge3gd2">
                  <div data-id="element-919" data-mp="21n52oa25xa2a">
                    <h4 className="font-semibold text-base text-gray-900" data-id="element-920" data-mp="26lge2p83vsmm">
                      {module.module}
                    </h4>
                    <p className="text-sm text-gray-500 mt-0.5" data-id="element-921" data-mp="1st09vl3gxok4">
                      {module.attempts} attempt
                      {module.attempts !== 1 ? 's' : ''}
                    </p>
                  </div>
                  <div className="text-right" data-id="element-922" data-mp="1iuap9kk6tq06">
                    <div className={`text-3xl font-bold ${module.score >= 85 ? 'text-[#007558]' : 'text-[#DB3725]'}`} data-id="element-923" data-mp="1nuoyv71ft80b">
                      {module.score}%
                    </div>
                    <div className="flex items-center justify-end gap-1.5 mt-1" data-id="element-924" data-mp="1dw0vnee42xgo">
                      {module.score >= 85 ? <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold bg-[#007558]/10 text-[#007558]" data-id="element-925" data-mp="349qb0pt1bq6v">
                          <CheckCircle size={12} data-id="element-926" data-mp="wmyiv7fm9pyg" />
                          Passed
                        </span> : <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold bg-[#DB3725]/10 text-[#DB3725]" data-id="element-927" data-mp="sng0aib9pqys">
                          <AlertTriangle size={12} data-id="element-928" data-mp="11m1e605soht8" />
                          Not Passed
                        </span>}
                    </div>
                    <div className="text-xs font-medium text-gray-500 mt-0.5" data-id="element-929" data-mp="1gdjz8cdih2jg">
                      Highest Assessment Score
                    </div>
                  </div>
                </div>

                {/* Confidence Analysis */}
                <div data-id="element-930" data-mp="1kcsvbnw0xci6">
                  <h5 className="text-sm font-semibold text-gray-700 mb-3" data-id="element-931" data-mp="1kecatc9uvjiw">
                    Answer Confidence Breakdown
                  </h5>

                  {/* Stacked Bar Visualization */}
                  <div className="mb-4" data-id="element-932" data-mp="3m5pdrvs9jhcb">
                    <div className="h-8 flex rounded-lg overflow-hidden shadow-sm" data-id="element-933" data-mp="3m6s2bx2457p2">
                      {/* Confident + Correct */}
                      <div className="bg-[#007558] flex items-center justify-center text-white text-xs font-bold transition-all duration-500 hover:opacity-90" style={{
                  width: `${module.confidentCorrect}%`
                }} title={`Confident & Correct: ${module.confidentCorrect}%`} data-id="element-934" data-mp="2sh9fuy8w5g9e">
                        {module.confidentCorrect >= 10 && `${module.confidentCorrect}%`}
                      </div>

                      {/* Uncertain + Correct */}
                      <div className="bg-[#10B981] flex items-center justify-center text-white text-xs font-bold transition-all duration-500 hover:opacity-90" style={{
                  width: `${module.uncertainCorrect}%`
                }} title={`Uncertain & Correct: ${module.uncertainCorrect}%`} data-id="element-935" data-mp="1ztvodfnypcwo">
                        {module.uncertainCorrect >= 10 && `${module.uncertainCorrect}%`}
                      </div>

                      {/* Confident + Incorrect */}
                      <div className="bg-[#DB3725] flex items-center justify-center text-white text-xs font-bold transition-all duration-500 hover:opacity-90" style={{
                  width: `${module.confidentIncorrect}%`
                }} title={`Confident & Incorrect: ${module.confidentIncorrect}%`} data-id="element-936" data-mp="k8l3hbt2rlbj">
                        {module.confidentIncorrect >= 10 && `${module.confidentIncorrect}%`}
                      </div>

                      {/* Uncertain + Incorrect */}
                      <div className="bg-[#F59E0B] flex items-center justify-center text-white text-xs font-bold transition-all duration-500 hover:opacity-90" style={{
                  width: `${module.uncertainIncorrect}%`
                }} title={`Uncertain & Incorrect: ${module.uncertainIncorrect}%`} data-id="element-937" data-mp="1cwqpe1vv7gcy">
                        {module.uncertainIncorrect >= 10 && `${module.uncertainIncorrect}%`}
                      </div>
                    </div>
                  </div>

                  {/* Legend Grid */}
                  <div className="grid grid-cols-2 gap-3" data-id="element-938" data-mp="2z3sd478h5pxx">
                    <div className="flex items-start gap-2" data-id="element-939" data-mp="2z5d8fz2m5cwu">
                      <div className="w-4 h-4 rounded bg-[#007558] flex-shrink-0 mt-0.5" data-id="element-940" data-mp="2uc0kzs9o7c5o"></div>
                      <div className="flex-1 min-w-0" data-id="element-941" data-mp="26lwtgj9rb2v1">
                        <div className="flex items-center gap-2" data-id="element-942" data-mp="22lmewi7wf44k">
                          <span className="text-xs font-bold text-[#007558] min-w-[32px]" data-id="element-943" data-mp="22le0glw4nqr9">
                            {module.confidentCorrect}%
                          </span>
                          <span className="text-xs font-semibold text-gray-700" data-id="element-944" data-mp="1x97grqacw5y6">
                            Confident & Correct
                          </span>
                        </div>
                        <p className="text-xs text-gray-500 mt-0.5 ml-[40px]" data-id="element-945" data-mp="1njnusbrcjvz3">
                          True mastery
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start gap-2" data-id="element-946" data-mp="2g68lda00041l">
                      <div className="w-4 h-4 rounded bg-[#10B981] flex-shrink-0 mt-0.5" data-id="element-947" data-mp="21a9iqevnqw3u"></div>
                      <div className="flex-1 min-w-0" data-id="element-948" data-mp="2693yf7ybw4jq">
                        <div className="flex items-center gap-2" data-id="element-949" data-mp="267j67ozhkxp1">
                          <span className="text-xs font-bold text-[#10B981] min-w-[32px]" data-id="element-950" data-mp="pukuzlakxt1z">
                            {module.uncertainCorrect}%
                          </span>
                          <span className="text-xs font-semibold text-gray-700" data-id="element-951" data-mp="1b0tmrh4ar746">
                            Uncertain & Correct
                          </span>
                        </div>
                        <p className="text-xs text-gray-500 mt-0.5 ml-[40px]" data-id="element-952" data-mp="11ba3wbgl3d9b">
                          Lucky guesses
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start gap-2" data-id="element-953" data-mp="1tzxr4ckw8cpi">
                      <div className="w-4 h-4 rounded bg-[#DB3725] flex-shrink-0 mt-0.5" data-id="element-954" data-mp="1tzfqz4v41ecb"></div>
                      <div className="flex-1 min-w-0" data-id="element-955" data-mp="1p1e408ukcuvk">
                        <div className="flex items-center gap-2" data-id="element-956" data-mp="1k18lbi69uipm">
                          <span className="text-xs font-bold text-[#DB3725] min-w-[32px]" data-id="element-957" data-mp="1k3uoz6q1ke2k">
                            {module.confidentIncorrect}%
                          </span>
                          <span className="text-xs font-semibold text-gray-700" data-id="element-958" data-mp="8nwdyxbazhyp">
                            Confident & Incorrect
                          </span>
                        </div>
                        <p className="text-xs text-gray-500 mt-0.5 ml-[40px]" data-id="element-959" data-mp="2fcgao8p690y5">
                          Misinformation
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start gap-2" data-id="element-960" data-mp="2p7gmb7qm4z5p">
                      <div className="w-4 h-4 rounded bg-[#F59E0B] flex-shrink-0 mt-0.5" data-id="element-961" data-mp="2u01antqr2k1u"></div>
                      <div className="flex-1 min-w-0" data-id="element-962" data-mp="2yzdx4ddplp3w">
                        <div className="flex items-center gap-2" data-id="element-963" data-mp="2z0xek7b3q679">
                          <span className="text-xs font-bold text-[#F59E0B] min-w-[32px]" data-id="element-964" data-mp="32z4ux11nl5hx">
                            {module.uncertainIncorrect}%
                          </span>
                          <span className="text-xs font-semibold text-gray-700" data-id="element-965" data-mp="3cyvpt3u4lmij">
                            Uncertain & Incorrect
                          </span>
                        </div>
                        <p className="text-xs text-gray-500 mt-0.5 ml-[40px]" data-id="element-966" data-mp="1ik2w5acsz5t8">
                          Needs practice
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>) : <div className="text-center py-8 text-gray-500" data-id="element-967" data-mp="1kim3lmzvnggj">
              No performance data available for {selectedSkill}.
            </div>}
        </div>
      </div>

      {/* Enhanced Mastery Heatmap */}
      <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-100" data-id="element-968" data-mp="1thpngt6vbzw3">
        <div className="mb-6" data-id="element-969" data-mp="1php9tarlfsq3">
          <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-970" data-mp="1pge7lfdsqt13">
            Knowledge Mastery Overview
          </h3>
          <p className="text-gray-600 text-sm" data-id="element-971" data-mp="237snvegbkg4g">
            Visual representation of {learner.name.split(' ')[0]}'s proficiency
            {selectedSkill === 'All Skills Combined' ? ' across all modules' : ` in ${selectedSkill}`}
          </p>
        </div>

        {filteredModulePerformance.length > 0 ? <div className={`grid gap-4 mb-8 ${filteredModulePerformance.length === 1 ? 'grid-cols-1 max-w-xs' : 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'}`} data-id="element-972" data-mp="2rtqgk6xm43w5">
            {filteredModulePerformance.map((module, index) => {
          const masteryLevel = module.mastery >= 90 ? 'expert' : module.mastery >= 75 ? 'proficient' : module.mastery >= 60 ? 'developing' : 'needs-work';
          const colorConfig = {
            expert: {
              bg: 'from-[#007558] to-[#005a44]',
              border: 'border-[#007558]',
              text: 'text-white',
              icon: '★'
            },
            proficient: {
              bg: 'from-[#30718D] to-[#265a70]',
              border: 'border-[#30718D]',
              text: 'text-white',
              icon: '✓'
            },
            developing: {
              bg: 'from-[#F59E0B] to-[#D97706]',
              border: 'border-[#F59E0B]',
              text: 'text-white',
              icon: '↗'
            },
            'needs-work': {
              bg: 'from-[#DB3725] to-[#b82e1f]',
              border: 'border-[#DB3725]',
              text: 'text-white',
              icon: '!'
            }
          };
          const config = colorConfig[masteryLevel];
          return <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9,
            y: 20
          }} animate={{
            opacity: 1,
            scale: 1,
            y: 0
          }} transition={{
            delay: index * 0.1,
            type: 'spring',
            stiffness: 200,
            damping: 20
          }} whileHover={{
            scale: 1.05,
            y: -4,
            transition: {
              duration: 0.2
            }
          }} className="group relative cursor-pointer" data-id="element-973" data-mp="1lxc5ba2knub7" data-mpi={index}>
                  <div className={`
                    relative overflow-hidden rounded-xl border-2 ${config.border}
                    bg-gradient-to-br ${config.bg}
                    shadow-md hover:shadow-xl
                    transition-all duration-300
                    aspect-square
                  `} data-id="element-974" data-mp="17ru0qtssxjjo">
                    {/* Shine effect on hover */}
                    <div className="absolute inset-0 bg-gradient-to-tr from-white/0 via-white/10 to-white/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-975" data-mp="ovu5na4j1zvv" />

                    {/* Content */}
                    <div className="relative h-full flex flex-col items-center justify-center p-6 text-center" data-id="element-976" data-mp="3sghs22vayqdr">
                      {/* Attempts Badge */}
                      <motion.div className="absolute top-3 right-3" initial={{
                  scale: 0
                }} animate={{
                  scale: 1
                }} transition={{
                  delay: index * 0.1 + 0.3,
                  type: 'spring'
                }} data-id="element-977" data-mp="3vb9gs73f4lr9">
                        <div className="bg-white/20 backdrop-blur-sm rounded-full px-2.5 py-1" data-id="element-978" data-mp="durv7n1o8k9g">
                          <span className={`text-xs font-bold ${config.text}`} data-id="element-979" data-mp="8wzv45qvhru6">
                            Attempts: {module.attempts}
                          </span>
                        </div>
                      </motion.div>

                      {/* Score */}
                      <motion.div initial={{
                  scale: 0
                }} animate={{
                  scale: 1
                }} transition={{
                  delay: index * 0.1 + 0.2,
                  type: 'spring',
                  stiffness: 300
                }} className="mb-3" data-id="element-980" data-mp="2tp1u92kt4033">
                        <div className={`text-5xl font-black ${config.text} drop-shadow-lg`} data-id="element-981" data-mp="32bmcyw4jccib">
                          {module.mastery}%
                        </div>
                      </motion.div>

                      {/* Module Name */}
                      <div className={`text-sm font-bold ${config.text} drop-shadow-md leading-tight px-2`} data-id="element-982" data-mp="3h46gvyzieo0t">
                        {module.module}
                      </div>

                      {/* Progress Ring */}
                      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 w-16 h-1 bg-white/30 rounded-full overflow-hidden" data-id="element-983" data-mp="1esbwkv3bc1uc">
                        <motion.div initial={{
                    width: 0
                  }} animate={{
                    width: `${module.mastery}%`
                  }} transition={{
                    delay: index * 0.1 + 0.4,
                    duration: 0.8
                  }} className="h-full bg-white/90 rounded-full" data-id="element-984" data-mp="19v3a4ib4tbna" />
                      </div>
                    </div>

                    {/* Hover Tooltip */}
                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl p-6 flex flex-col justify-center bg-white shadow-xl" data-id="element-985" data-mp="2ggnsuy6i8gqp">
                      <div className="space-y-3" data-id="element-986" data-mp="2v3uta9yd5wbc">
                        <div className="text-base font-bold border-b border-gray-200 pb-2 text-gray-900" data-id="element-987" data-mp="2v55vw6g2oy0v">
                          {module.module}
                        </div>

                        <div className="space-y-2 text-sm" data-id="element-988" data-mp="2m3zi454t61bb">
                          <div className="flex justify-between items-center" data-id="element-989" data-mp="2r29ay9328ptr">
                            <span className="text-gray-600" data-id="element-990" data-mp="2r4dozjuob57r">
                              Overall Score:
                            </span>
                            <span className="font-bold text-gray-900" data-id="element-991" data-mp="2h4mu3h27ao75">
                              {module.score}%
                            </span>
                          </div>

                          <div className="flex justify-between items-center" data-id="element-992" data-mp="27ea0z0gblmpe">
                            <span className="text-gray-600" data-id="element-993" data-mp="27c7dan2n45nu">Mastery:</span>
                            <span className="font-bold text-[#007558]" data-id="element-994" data-mp="1tf0wgy1h8h19">
                              {module.mastery}%
                            </span>
                          </div>

                          <div className="flex justify-between items-center" data-id="element-995" data-mp="30pq7qlimbgqr">
                            <span className="text-gray-600" data-id="element-996" data-mp="2wp6alhy1od4m">
                              Misinformation:
                            </span>
                            <span className="font-bold text-[#DB3725]" data-id="element-997" data-mp="2rwvd0lqs13f8">
                              {module.misinformation}%
                            </span>
                          </div>

                          <div className="flex justify-between items-center pt-2 border-t border-gray-200" data-id="element-998" data-mp="2i23ar4m91se4">
                            <span className="text-gray-600" data-id="element-999" data-mp="2d04c281gfjni">Attempts:</span>
                            <span className="font-bold text-[#30718D]" data-id="element-1000" data-mp="290n3h5qqe6e4">
                              {module.attempts}
                            </span>
                          </div>
                        </div>

                        <div className="pt-2" data-id="element-1001" data-mp="77pghqjmy813">
                          <div className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold border ${masteryLevel === 'expert' ? 'bg-[#007558]/30 text-[#007558] border-[#007558]/50' : masteryLevel === 'proficient' ? 'bg-[#30718D]/30 text-[#30718D] border-[#30718D]/50' : masteryLevel === 'developing' ? 'bg-[#F59E0B]/30 text-[#F59E0B] border-[#F59E0B]/50' : 'bg-[#DB3725]/30 text-[#DB3725] border-[#DB3725]/50'}`} data-id="element-1002" data-mp="28uopz3ox94u">
                            <span data-id="element-1003" data-mp="3mzymzi0krpvp">{config.icon}</span>
                            <span data-id="element-1004" data-mp="3n19p7dedgpkp">
                              {masteryLevel === 'expert' ? 'Expert Level' : masteryLevel === 'proficient' ? 'Proficient' : masteryLevel === 'developing' ? 'Developing' : 'Needs Focus'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>;
        })}
          </div> : <div className="text-center py-8 text-gray-500" data-id="element-1005" data-mp="389qs3f6sis67">
            No performance data available for {selectedSkill}.
          </div>}

        {/* Enhanced Legend */}
        <div className="bg-gray-50 rounded-xl p-6 border border-gray-200" data-id="element-1006" data-mp="3hayplv1hfoz8">
          <h4 className="text-sm font-bold text-gray-700 mb-4 uppercase tracking-wide" data-id="element-1007" data-mp="2tlcpn5dad5q6">
            Mastery Levels
          </h4>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-1008" data-mp="2pl28qxnyguwj">
            <div className="flex items-center gap-3" data-id="element-1009" data-mp="33b5r3djps4gp">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#DB3725] to-[#b82e1f] shadow-md flex items-center justify-center flex-shrink-0" data-id="element-1010" data-mp="33d0f50qa8cp0">
                <span className="text-white font-bold text-lg" data-id="element-1011" data-mp="2aumktb45n8uo">!</span>
              </div>
              <div data-id="element-1012" data-mp="25wbgth0jjskd">
                <div className="font-bold text-gray-900 text-sm" data-id="element-1013" data-mp="25v0ab9fpo6pk">
                  Needs Work
                </div>
                <div className="text-xs text-gray-500" data-id="element-1014" data-mp="ld7nseksiwwb">0-59%</div>
              </div>
            </div>

            <div className="flex items-center gap-3" data-id="element-1015" data-mp="q6ahqnthc8d1">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#F59E0B] to-[#D97706] shadow-md flex items-center justify-center flex-shrink-0" data-id="element-1016" data-mp="cdkr2630af9l">
                <span className="text-white font-bold text-lg" data-id="element-1017" data-mp="hcnnj24x7d5y">↗</span>
              </div>
              <div data-id="element-1018" data-mp="152hzlhhf0xp5">
                <div className="font-bold text-gray-900 text-sm" data-id="element-1019" data-mp="14zvwpv5gz6d9">
                  Developing
                </div>
                <div className="text-xs text-gray-500" data-id="element-1020" data-mp="v3ss8in5avn5">60-74%</div>
              </div>
            </div>

            <div className="flex items-center gap-3" data-id="element-1021" data-mp="102n8bctqa63k">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#30718D] to-[#265a70] shadow-md flex items-center justify-center flex-shrink-0" data-id="element-1022" data-mp="101c8tp7bfki9">
                <span className="text-white font-bold text-lg" data-id="element-1023" data-mp="3ktnshu3iz7ph">✓</span>
              </div>
              <div data-id="element-1024" data-mp="gb1pxrft66i5">
                <div className="font-bold text-gray-900 text-sm" data-id="element-1025" data-mp="gbl3kvyfe8qd">
                  Proficient
                </div>
                <div className="text-xs text-gray-500" data-id="element-1026" data-mp="bbfbxfs5om8a">75-89%</div>
              </div>
            </div>

            <div className="flex items-center gap-3" data-id="element-1027" data-mp="6dnighbv4s1z">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#007558] to-[#005a44] shadow-md flex items-center justify-center flex-shrink-0" data-id="element-1028" data-mp="1eao7binwipd">
                <span className="text-white font-bold text-lg" data-id="element-1029" data-mp="z115nnpre98w">★</span>
              </div>
              <div data-id="element-1030" data-mp="u382z4nnzxdd">
                <div className="font-bold text-gray-900 text-sm" data-id="element-1031" data-mp="u4svkoqf568l">Mastery</div>
                <div className="text-xs text-gray-500" data-id="element-1032" data-mp="paevi90taaxl">90-100%</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>;
}
function MetricCard({
  icon,
  label,
  value,
  change,
  changeLabel,
  color
}) {
  const colorClasses = {
    blue: 'bg-[#30718D]/10 text-[#30718D]',
    green: 'bg-[#007558]/10 text-[#007558]',
    purple: 'bg-[#30718D]/10 text-[#30718D]',
    orange: 'bg-orange-100 text-orange-600'
  };
  const isPositive = change > 0;
  const isNeutral = change === 0;
  return <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-1033" data-mp="1pdw7o6pj5d46">
      <div className="flex items-center justify-between mb-2" data-id="element-1034" data-mp="1u9bkcvbsx2z0">
        <span className="text-sm font-medium text-gray-600" data-id="element-1035" data-mp="1zaitoytlea7s">{label}</span>
        {isPositive ? <TrendingUp size={20} className="text-green-600" data-id="element-1036" data-mp="249vp47yj4plz" /> : isNeutral ? <Minus size={20} className="text-gray-400" data-id="element-1037" data-mp="28afid0fzf92u" /> : <TrendingUp size={20} className="text-red-600 rotate-180" data-id="element-1038" data-mp="288l23zfno553" />}
      </div>
      <div className="flex items-end justify-between" data-id="element-1039" data-mp="2d25wzilycj02">
        <div className="text-3xl font-bold text-gray-900" data-id="element-1040" data-mp="2i0qq6y2se2f0">{value}</div>
        <span className={`text-lg font-bold ${isPositive ? 'text-green-600' : isNeutral ? 'text-gray-500' : 'text-red-600'}`} data-id="element-1041" data-mp="2mzk1cjulphc0">
          {isPositive ? '+' : ''}
          {change}%
        </span>
      </div>
    </div>;
}
function SkillPerformanceHeader({
  selectedInsightSkill,
  setSelectedInsightSkill,
  isInsightSkillDropdownOpen,
  setIsInsightSkillDropdownOpen,
  insightSkillDropdownRef,
  skillOptions
}) {
  return <div className="bg-white px-4 sm:px-6 py-5 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4" data-id="element-1042" data-mp="3kqxvi45ayo4o">
      <div data-id="element-1043" data-mp="gbejsyn11x0w">
        <h4 className="text-base font-bold text-gray-900 mb-0.5 flex items-center gap-2" data-id="element-1044" data-mp="gawgxj5v0kk0">
          <BarChart3 size={22} className="text-[#30718D]" data-id="element-1045" data-mp="la81z4d9ec7e" />
          Skill Performance
        </h4>
        <p className="text-sm text-gray-500 ml-[26px]" data-id="element-1046" data-mp="7jcn9bg2x0vw">
          {selectedInsightSkill === 'All Skills Combined' ? 'Detailed metrics for all skills' : `Detailed metrics for ${selectedInsightSkill}`}
        </p>
      </div>
      <div className="relative" ref={insightSkillDropdownRef} data-id="element-1047" data-mp="z8pl0os7z0iz">
        <button onClick={() => setIsInsightSkillDropdownOpen(!isInsightSkillDropdownOpen)} className="flex items-center gap-2 px-3 sm:px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white text-sm font-bold text-gray-900 w-full sm:min-w-[200px]" data-id="element-1048" data-mp="141irpi790ixp">
          <Target size={16} className="text-[#30718D]" data-id="element-1049" data-mp="2ygo53hhzhn7v" />
          <span className="flex-1 text-left" data-id="element-1050" data-mp="2tie60vt522gz">{selectedInsightSkill}</span>
          <ChevronDown size={16} className={`transition-transform text-gray-500 ${isInsightSkillDropdownOpen ? 'rotate-180' : ''}`} data-id="element-1051" data-mp="2tkgx7j6121na" />
        </button>

        {isInsightSkillDropdownOpen && <div className="absolute top-full mt-2 right-0 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-10" data-id="element-1052" data-mp="2fr95lrhy565l">
            {skillOptions.map(skill => <button key={skill} onClick={() => {
          setSelectedInsightSkill(skill);
          setIsInsightSkillDropdownOpen(false);
        }} className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0 text-sm ${selectedInsightSkill === skill ? 'bg-[#30718D]/5 text-[#30718D] font-semibold' : 'text-gray-700'}`} data-id="element-1053" data-mp="2atzjoltrncmi">
                {skill}
              </button>)}
          </div>}
      </div>
    </div>;
}